// // // // // import React, { useState, useEffect } from 'react';
// // // // // import { useDispatch, useSelector } from 'react-redux';
// // // // // // import {
// // // // // //   createCashTransaction,
// // // // // //   fetchCashTransactions,
// // // // // //   closeRegister,
// // // // // //   fetchCashSummary,
// // // // // // } from '../actions/cashTransactionActions';
// // // // // import {
// // // // //   Button,
// // // // //   TextField,
// // // // //   Table,
// // // // //   TableBody,
// // // // //   TableCell,
// // // // //   TableHead,
// // // // //   TableRow,
// // // // //   Paper,
// // // // //   Typography,
// // // // //   Grid,
// // // // //   Snackbar,
// // // // // } from '@material-ui/core';
// // // // // import { makeStyles } from '@material-ui/core/styles';
// // // // // import moment from 'moment';
// // // // // import { closeRegister, createCashTransaction, fetchCashSummary, fetchCashTransactions } from '../../actions/cashTransactionActions';

// // // // // const useStyles = makeStyles((theme) => ({
// // // // //   root: {
// // // // //     padding: theme.spacing(3),
// // // // //   },
// // // // //   section: {
// // // // //     marginBottom: theme.spacing(4),
// // // // //   },
// // // // //   table: {
// // // // //     minWidth: 650,
// // // // //   },
// // // // //   form: {
// // // // //     display: 'flex',
// // // // //     flexDirection: 'column',
// // // // //     gap: theme.spacing(2),
// // // // //     maxWidth: 400,
// // // // //   },
// // // // //   summaryCard: {
// // // // //     padding: theme.spacing(2),
// // // // //     background: '#f5f5f5',
// // // // //     borderRadius: 8,
// // // // //   },
// // // // // }));

// // // // // const CashManagement = () => {
// // // // //   const classes = useStyles();
// // // // //   const dispatch = useDispatch();
// // // // //   const { transactions, summary, isLoading } = useSelector((state) => state.cashTransactions);
// // // // //   const user = JSON.parse(localStorage.getItem('profile'));

// // // // //   const [openForm, setOpenForm] = useState({ type: '', open: false });
// // // // //   const [amount, setAmount] = useState('');
// // // // //   const [notes, setNotes] = useState('');
// // // // //   const [denominations, setDenominations] = useState({
// // // // //     1000: 0,
// // // // //     500: 0,
// // // // //     100: 0,
// // // // //     50: 0,
// // // // //     20: 0,
// // // // //   });
// // // // //   const [cashOutAmount, setCashOutAmount] = useState('');
// // // // //   const [snackbar, setSnackbar] = useState({ open: false, message: '' });

// // // // //   useEffect(() => {
// // // // //     const today = moment().format('YYYY-MM-DD');
// // // // //     dispatch(fetchCashSummary(today));
// // // // //     dispatch(fetchCashTransactions(today, today));
// // // // //   }, [dispatch]);

// // // // //   const handleOpenForm = (type) => {
// // // // //     setOpenForm({ type, open: true });
// // // // //     setAmount('');
// // // // //     setNotes('');
// // // // //     setDenominations({ 1000: 0, 500: 0, 100: 0, 50: 0, 20: 0 });
// // // // //   };

// // // // //   const handleSubmit = () => {
// // // // //     const totalAmount = Object.entries(denominations).reduce(
// // // // //       (sum, [denom, count]) => sum + parseInt(denom) * count,
// // // // //       0
// // // // //     );

// // // // //     const transaction = {
// // // // //       type: openForm.type,
// // // // //       amount: openForm.type === 'OPENING' || openForm.type === 'CASH_IN' ? totalAmount : parseFloat(amount),
// // // // //       denominations: openForm.type === 'OPENING' || openForm.type === 'CASH_IN' ? denominations : {},
// // // // //       notes,
// // // // //       creator: user?.result?._id,
// // // // //     };

// // // // //     dispatch(createCashTransaction(transaction, (success, error) => {
// // // // //       if (success) {
// // // // //         setSnackbar({ open: true, message: 'Transaction recorded successfully' });
// // // // //         setOpenForm({ type: '', open: false });
// // // // //       } else {
// // // // //         setSnackbar({ open: true, message: error || 'Error recording transaction' });
// // // // //       }
// // // // //     }));
// // // // //   };

// // // // //   const handleCloseRegister = () => {
// // // // //     dispatch(closeRegister({ cashOutAmount: parseFloat(cashOutAmount), notes }, (success, error) => {
// // // // //       if (success) {
// // // // //         setSnackbar({ open: true, message: 'Register closed successfully' });
// // // // //         setCashOutAmount('');
// // // // //         setNotes('');
// // // // //       } else {
// // // // //         setSnackbar({ open: true, message: error || 'Error closing register' });
// // // // //       }
// // // // //     }));
// // // // //   };

// // // // //   const formatCurrency = (value) =>
// // // // //     `₹${Number(value).toLocaleString('en-US', {
// // // // //       minimumFractionDigits: 2,
// // // // //       maximumFractionDigits: 2,
// // // // //     })}`;

// // // // //   return (
// // // // //     <div className={classes.root}>
// // // // //       <Typography variant="h4" className={classes.section}>
// // // // //         Cash Management
// // // // //       </Typography>

// // // // //       {/* Action Buttons */}
// // // // //       <Grid container spacing={2} className={classes.section}>
// // // // //         <Grid item>
// // // // //           <Button
// // // // //             variant="contained"
// // // // //             color="primary"
// // // // //             onClick={() => handleOpenForm('OPENING')}
// // // // //             disabled={summary?.openingBalance > 0}
// // // // //           >
// // // // //             Open Register
// // // // //           </Button>
// // // // //         </Grid>
// // // // //         <Grid item>
// // // // //           <Button
// // // // //             variant="contained"
// // // // //             color="primary"
// // // // //             onClick={() => handleOpenForm('CASH_IN')}
// // // // //           >
// // // // //             Cash In
// // // // //           </Button>
// // // // //         </Grid>
// // // // //         <Grid item>
// // // // //           <Button
// // // // //             variant="contained"
// // // // //             color="primary"
// // // // //             onClick={() => handleOpenForm('CASH_OUT')}
// // // // //           >
// // // // //             Cash Out
// // // // //           </Button>
// // // // //         </Grid>
// // // // //         <Grid item>
// // // // //           <Button
// // // // //             variant="contained"
// // // // //             color="secondary"
// // // // //             onClick={() => setOpenForm({ type: 'CLOSING', open: true })}
// // // // //           >
// // // // //             Close Register
// // // // //           </Button>
// // // // //         </Grid>
// // // // //       </Grid>

// // // // //       {/* Cash Transaction Form */}
// // // // //       {openForm.open && (
// // // // //         <Paper className={classes.form}>
// // // // //           <Typography variant="h6">
// // // // //             {openForm.type === 'OPENING'
// // // // //               ? 'Open Register'
// // // // //               : openForm.type === 'CASH_IN'
// // // // //               ? 'Cash In'
// // // // //               : openForm.type === 'CASH_OUT'
// // // // //               ? 'Cash Out'
// // // // //               : 'Close Register'}
// // // // //           </Typography>
// // // // //           {(openForm.type === 'OPENING' || openForm.type === 'CASH_IN') && (
// // // // //             <>
// // // // //               {Object.keys(denominations).map((denom) => (
// // // // //                 <TextField
// // // // //                   key={denom}
// // // // //                   label={`${denom} Notes`}
// // // // //                   type="number"
// // // // //                   value={denominations[denom]}
// // // // //                   onChange={(e) =>
// // // // //                     setDenominations({
// // // // //                       ...denominations,
// // // // //                       [denom]: parseInt(e.target.value) || 0,
// // // // //                     })
// // // // //                   }
// // // // //                 />
// // // // //               ))}
// // // // //             </>
// // // // //           )}
// // // // //           {(openForm.type === 'CASH_OUT' || openForm.type === 'CLOSING') && (
// // // // //             <TextField
// // // // //               label="Amount"
// // // // //               type="number"
// // // // //               value={openForm.type === 'CLOSING' ? cashOutAmount : amount}
// // // // //               onChange={(e) =>
// // // // //                 openForm.type === 'CLOSING'
// // // // //                   ? setCashOutAmount(e.target.value)
// // // // //                   : setAmount(e.target.value)
// // // // //               }
// // // // //             />
// // // // //           )}
// // // // //           <TextField
// // // // //             label="Notes"
// // // // //             multiline
// // // // //             rows={4}
// // // // //             value={notes}
// // // // //             onChange={(e) => setNotes(e.target.value)}
// // // // //           />
// // // // //           <Button
// // // // //             variant="contained"
// // // // //             color="primary"
// // // // //             onClick={openForm.type === 'CLOSING' ? handleCloseRegister : handleSubmit}
// // // // //           >
// // // // //             Submit
// // // // //           </Button>
// // // // //           <Button
// // // // //             variant="outlined"
// // // // //             onClick={() => setOpenForm({ type: '', open: false })}
// // // // //           >
// // // // //             Cancel
// // // // //           </Button>
// // // // //         </Paper>
// // // // //       )}

// // // // //       {/* Summary Section */}
// // // // //       {summary && (
// // // // //         <div className={classes.summaryCard}>
// // // // //           <Typography variant="h6">Today's Cash Summary</Typography>
// // // // //           <Typography>Opening Balance: {formatCurrency(summary.openingBalance)}</Typography>
// // // // //           <Typography>Total Sales: {formatCurrency(summary.totalSales)}</Typography>
// // // // //           <Typography>Cash In: {formatCurrency(summary.cashIn)}</Typography>
// // // // //           <Typography>Cash Out: {formatCurrency(summary.cashOut)}</Typography>
// // // // //           <Typography>Closing Balance: {formatCurrency(summary.closingBalance)}</Typography>
// // // // //         </div>
// // // // //       )}

// // // // //       {/* Transaction History */}
// // // // //       <Paper className={classes.section}>
// // // // //         <Typography variant="h6">Transaction History</Typography>
// // // // //         <Table className={classes.table}>
// // // // //           <TableHead>
// // // // //             <TableRow>
// // // // //               <TableCell>Date</TableCell>
// // // // //               <TableCell>Type</TableCell>
// // // // //               <TableCell>Amount</TableCell>
// // // // //               <TableCell>Notes</TableCell>
// // // // //               <TableCell>Denominations</TableCell>
// // // // //             </TableRow>
// // // // //           </TableHead>
// // // // //           <TableBody>
// // // // //             {transactions.map((tx) => (
// // // // //               <TableRow key={tx._id}>
// // // // //                 <TableCell>{moment(tx.date).format('DD/MM/YYYY HH:mm')}</TableCell>
// // // // //                 <TableCell>{tx.type}</TableCell>
// // // // //                 <TableCell>{formatCurrency(tx.amount)}</TableCell>
// // // // //                 <TableCell>{tx.notes}</TableCell>
// // // // //                 <TableCell>
// // // // //                   {Object.entries(tx.denominations).map(([denom, count]) => (
// // // // //                     count > 0 && <div key={denom}>{`${denom}: ${count}`}</div>
// // // // //                   ))}
// // // // //                 </TableCell>
// // // // //               </TableRow>
// // // // //             ))}
// // // // //           </TableBody>
// // // // //         </Table>
// // // // //       </Paper>

// // // // //       <Snackbar
// // // // //         open={snackbar.open}
// // // // //         autoHideDuration={6000}
// // // // //         onClose={() => setSnackbar({ ...snackbar, open: false })}
// // // // //         message={snackbar.message}
// // // // //       />
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default CashManagement;

// // // // import React, { useState, useEffect } from 'react';
// // // // import { useDispatch, useSelector } from 'react-redux';
// // // // import {
// // // //   createCashTransaction,
// // // //   fetchCashTransactions,
// // // //   closeRegister,
// // // //   fetchCashSummary,
// // // // } from '../../actions/cashTransactionActions';
// // // // import {
// // // //   Button,
// // // //   TextField,
// // // //   Table,
// // // //   TableBody,
// // // //   TableCell,
// // // //   TableHead,
// // // //   TableRow,
// // // //   Paper,
// // // //   Typography,
// // // //   Grid,
// // // //   Snackbar,
// // // //   CircularProgress,
// // // //   Card,
// // // //   CardContent,
// // // //   IconButton,
// // // //   Box,
// // // // } from '@material-ui/core';
// // // // import { makeStyles } from '@material-ui/core/styles';
// // // // import { Close as CloseIcon, AccountBalanceWallet as WalletIcon } from '@material-ui/icons';
// // // // import moment from 'moment';
// // // // import { Alert } from '@material-ui/lab';

// // // // const useStyles = makeStyles((theme) => ({
// // // //   root: {
// // // //     padding: theme.spacing(4),
// // // //     backgroundColor: '#fafafa',
// // // //     marginLeft:"85px",
// // // //     minHeight: '100vh',
// // // //     [theme.breakpoints.down('sm')]: {
// // // //       padding: theme.spacing(2),
// // // //     },
    
// // // //   },
// // // //   header: {
// // // //     marginBottom: theme.spacing(3),
// // // //     fontWeight: 600,
// // // //     color: theme.palette.primary.dark,
// // // //   },
// // // //   section: {
// // // //     marginBottom: theme.spacing(4),
// // // //   },
// // // //   actionButton: {
// // // //     textTransform: 'none',
// // // //     fontWeight: 500,
// // // //     padding: theme.spacing(1.5, 3),
// // // //     borderRadius: 8,
// // // //     transition: 'all 0.3s ease',
// // // //     '&:hover': {
// // // //       transform: 'translateY(-2px)',
// // // //       boxShadow: theme.shadows[4],
// // // //     },
// // // //   },
// // // //   closeButton: {
// // // //     backgroundColor: theme.palette.error.main,
// // // //     color: '#fff',
// // // //     '&:hover': {
// // // //       backgroundColor: theme.palette.error.dark,
// // // //     },
// // // //   },
// // // //   formContainer: {
// // // //     padding: theme.spacing(3),
// // // //     borderRadius: 12,
// // // //     boxShadow: theme.shadows[3],
// // // //     backgroundColor: '#fff',
// // // //     maxWidth: 500,
// // // //     margin: '0 auto',
// // // //   },
// // // //   formField: {
// // // //     marginBottom: theme.spacing(2),
// // // //   },
// // // //   denominationField: {
// // // //     '& input': {
// // // //       textAlign: 'right',
// // // //     },
// // // //   },
// // // //   cancelButton: {
// // // //     marginRight: theme.spacing(2),
// // // //   },
// // // //   summaryCard: {
// // // //     borderRadius: 12,
// // // //     boxShadow: theme.shadows[3],
// // // //     backgroundColor: '#fff',
// // // //     padding: theme.spacing(3),
// // // //     marginBottom: theme.spacing(4),
// // // //   },
// // // //   summaryItem: {
// // // //     display: 'flex',
// // // //     alignItems: 'center',
// // // //     marginBottom: theme.spacing(1.5),
// // // //     '& svg': {
// // // //       marginRight: theme.spacing(1.5),
// // // //       color: theme.palette.primary.main,
// // // //     },
// // // //   },
// // // //   tableContainer: {
// // // //     borderRadius: 12,
// // // //     boxShadow: theme.shadows[3],
// // // //     overflowX: 'auto',
// // // //   },
// // // //   table: {
// // // //     minWidth: 650,
// // // //     [theme.breakpoints.down('sm')]: {
// // // //       minWidth: 300,
// // // //     },
// // // //   },
// // // //   tableHeader: {
// // // //     backgroundColor: theme.palette.primary.light,
// // // //     '& th': {
// // // //       fontWeight: 600,
// // // //       color: theme.palette.primary.contrastText,
// // // //     },
// // // //   },
// // // //   tableRow: {
// // // //     '&:hover': {
// // // //       backgroundColor: theme.palette.action.hover,
// // // //     },
// // // //   },
// // // //   tableTitle: {
// // // //     padding: theme.spacing(2),
// // // //   },
// // // //   loadingContainer: {
// // // //     display: 'flex',
// // // //     justifyContent: 'center',
// // // //     alignItems: 'center',
// // // //     minHeight: 200,
// // // //   },
// // // //   snackbar: {
// // // //     maxWidth: 400,
// // // //   },
// // // // }));

// // // // const CashManagement = () => {
// // // //   const classes = useStyles();
// // // //   const dispatch = useDispatch();
// // // //   const { transactions, summary, isLoading } = useSelector((state) => state.cashTransactions);
// // // //   const user = JSON.parse(localStorage.getItem('profile'));

// // // //   const [openForm, setOpenForm] = useState({ type: '', open: false });
// // // //   const [amount, setAmount] = useState('');
// // // //   const [notes, setNotes] = useState('');
// // // //   const [denominations, setDenominations] = useState({
// // // //     1000: 0,
// // // //     500: 0,
// // // //     100: 0,
// // // //     50: 0,
// // // //     20: 0,
// // // //   });
// // // //   const [cashOutAmount, setCashOutAmount] = useState('');
// // // //   const [formErrors, setFormErrors] = useState({});
// // // //   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

// // // //   useEffect(() => {
// // // //     const today = moment().format('YYYY-MM-DD');
// // // //     dispatch(fetchCashSummary(today));
// // // //     dispatch(fetchCashTransactions(today, today));
// // // //   }, [dispatch]);

// // // //   const validateForm = () => {
// // // //     const errors = {};
// // // //     if (openForm.type === 'OPENING' || openForm.type === 'CASH_IN') {
// // // //       const totalAmount = Object.entries(denominations).reduce(
// // // //         (sum, [denom, count]) => sum + parseInt(denom) * count,
// // // //         0
// // // //       );
// // // //       if (totalAmount <= 0) {
// // // //         errors.denominations = 'Please enter at least one denomination';
// // // //       }
// // // //     }
// // // //     if (openForm.type === 'CASH_OUT' && (!amount || parseFloat(amount) <= 0)) {
// // // //       errors.amount = 'Please enter a valid amount';
// // // //     }
// // // //     if (openForm.type === 'CLOSING' && cashOutAmount && parseFloat(cashOutAmount) < 0) {
// // // //       errors.cashOutAmount = 'Cash out amount cannot be negative';
// // // //     }
// // // //     setFormErrors(errors);
// // // //     return Object.keys(errors).length === 0;
// // // //   };

// // // //       useEffect(() => {
// // // //       console.log("transactions dataa ------------:", transactions);
// // // //     }, [transactions]);

// // // //   const handleOpenForm = (type) => {
// // // //     setOpenForm({ type, open: true });
// // // //     setAmount('');
// // // //     setNotes('');
// // // //     setDenominations({ 1000: 0, 500: 0, 100: 0, 50: 0, 20: 0 });
// // // //     setCashOutAmount('');
// // // //     setFormErrors({});
// // // //   };

// // // //   const handleSubmit = () => {
// // // //     if (!validateForm()) return;

// // // //     const totalAmount = Object.entries(denominations).reduce(
// // // //       (sum, [denom, count]) => sum + parseInt(denom) * count,
// // // //       0
// // // //     );

// // // //     const transaction = {
// // // //       type: openForm.type,
// // // //       amount: openForm.type === 'OPENING' || openForm.type === 'CASH_IN' ? totalAmount : parseFloat(amount),
// // // //       denominations: openForm.type === 'OPENING' || openForm.type === 'CASH_IN' ? denominations : {},
// // // //       notes,
// // // //       creator: user?.result?._id,
// // // //     };

// // // //     dispatch(createCashTransaction(transaction, (success, error) => {
// // // //       if (success) {
// // // //         setSnackbar({ open: true, message: 'Transaction recorded successfully', severity: 'success' });
// // // //         setOpenForm({ type: '', open: false });
// // // //       } else {
// // // //         setSnackbar({ open: true, message: error || 'Error recording transaction', severity: 'error' });
// // // //       }
// // // //     }));
// // // //   };

// // // //   const handleCloseRegister = () => {
// // // //     if (!validateForm()) return;

// // // //     dispatch(closeRegister({ cashOutAmount: parseFloat(cashOutAmount) || 0, notes }, (success, error) => {
// // // //       if (success) {
// // // //         setSnackbar({ open: true, message: 'Register closed successfully', severity: 'success' });
// // // //         setCashOutAmount('');
// // // //         setNotes('');
// // // //         setOpenForm({ type: '', open: false });
// // // //       } else {
// // // //         setSnackbar({ open: true, message: error || 'Error closing register', severity: 'error' });
// // // //       }
// // // //     }));
// // // //   };

// // // //   const formatCurrency = (value) =>
// // // //     `₹${Number(value || 0).toLocaleString('en-US', {
// // // //       minimumFractionDigits: 2,
// // // //       maximumFractionDigits: 2,
// // // //     })}`;

// // // //   return (
// // // //     <div className={classes.root}>
// // // //       <Typography variant="h4" className={classes.header}>
// // // //         Cash Management
// // // //       </Typography>

// // // //       {/* Action Buttons */}
// // // //       <Grid container spacing={2} className={classes.section}>
// // // //         <Grid item xs={6} sm={3}>
// // // //           <Button
// // // //             variant="contained"
// // // //             color="primary"
// // // //             fullWidth
// // // //             className={classes.actionButton}
// // // //             onClick={() => handleOpenForm('OPENING')}
// // // //             disabled={summary?.openingBalance > 0}
// // // //           >
// // // //             Open Register
// // // //           </Button>
// // // //         </Grid>
// // // //         <Grid item xs={6} sm={3}>
// // // //           <Button
// // // //             variant="contained"
// // // //             color="primary"
// // // //             fullWidth
// // // //             className={classes.actionButton}
// // // //             onClick={() => handleOpenForm('CASH_IN')}
// // // //           >
// // // //             Cash In
// // // //           </Button>
// // // //         </Grid>
// // // //         <Grid item xs={6} sm={3}>
// // // //           <Button
// // // //             variant="contained"
// // // //             color="primary"
// // // //             fullWidth
// // // //             className={classes.actionButton}
// // // //             onClick={() => handleOpenForm('CASH_OUT')}
// // // //           >
// // // //             Cash Out
// // // //           </Button>
// // // //         </Grid>
// // // //         <Grid item xs={6} sm={3}>
// // // //           <Button
// // // //             variant="contained"
// // // //             fullWidth
// // // //             className={`${classes.actionButton} ${classes.closeButton}`}
// // // //             onClick={() => setOpenForm({ type: 'CLOSING', open: true })}
// // // //           >
// // // //             Close Register
// // // //           </Button>
// // // //         </Grid>
// // // //       </Grid>

// // // //       {/* Cash Transaction Form */}
// // // //       {openForm.open && (
// // // //         <Paper className={classes.formContainer}>
// // // //           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
// // // //             <Typography variant="h6">
// // // //               {openForm.type === 'OPENING'
// // // //                 ? 'Open Register'
// // // //                 : openForm.type === 'CASH_IN'
// // // //                 ? 'Cash In'
// // // //                 : openForm.type === 'CASH_OUT'
// // // //                 ? 'Cash Out'
// // // //                 : 'Close Register'}
// // // //             </Typography>
// // // //             <IconButton onClick={() => setOpenForm({ type: '', open: false })}>
// // // //               <CloseIcon />
// // // //             </IconButton>
// // // //           </Box>
// // // //           <Box>
// // // //             {(openForm.type === 'OPENING' || openForm.type === 'CASH_IN') && (
// // // //               <>
// // // //                 {Object.keys(denominations).map((denom) => (
// // // //                   <TextField
// // // //                     key={denom}
// // // //                     label={`${denom} Notes`}
// // // //                     type="number"
// // // //                     fullWidth
// // // //                     className={`${classes.formField} ${classes.denominationField}`}
// // // //                     value={denominations[denom]}
// // // //                     onChange={(e) =>
// // // //                       setDenominations({
// // // //                         ...denominations,
// // // //                         [denom]: parseInt(e.target.value) || 0,
// // // //                       })
// // // //                     }
// // // //                     error={!!formErrors.denominations}
// // // //                     helperText={formErrors.denominations}
// // // //                   />
// // // //                 ))}
// // // //               </>
// // // //             )}
// // // //             {(openForm.type === 'CASH_OUT' || openForm.type === 'CLOSING') && (
// // // //               <TextField
// // // //                 label="Amount"
// // // //                 type="number"
// // // //                 fullWidth
// // // //                 className={classes.formField}
// // // //                 value={openForm.type === 'CLOSING' ? cashOutAmount : amount}
// // // //                 onChange={(e) =>
// // // //                   openForm.type === 'CLOSING'
// // // //                     ? setCashOutAmount(e.target.value)
// // // //                     : setAmount(e.target.value)
// // // //                 }
// // // //                 error={!!formErrors.amount || !!formErrors.cashOutAmount}
// // // //                 helperText={formErrors.amount || formErrors.cashOutAmount}
// // // //               />
// // // //             )}
// // // //             <TextField
// // // //               label="Notes"
// // // //               multiline
// // // //               rows={4}
// // // //               fullWidth
// // // //               className={classes.formField}
// // // //               value={notes}
// // // //               onChange={(e) => setNotes(e.target.value)}
// // // //             />
// // // //             <Box display="flex" justifyContent="flex-end" mt={2}>
// // // //               <Button
// // // //                 variant="outlined"
// // // //                 color="primary"
// // // //                 className={classes.cancelButton}
// // // //                 onClick={() => setOpenForm({ type: '', open: false })}
// // // //               >
// // // //                 Cancel
// // // //               </Button>
// // // //               <Button
// // // //                 variant="contained"
// // // //                 color="primary"
// // // //                 onClick={openForm.type === 'CLOSING' ? handleCloseRegister : handleSubmit}
// // // //               >
// // // //                 Submit
// // // //               </Button>
// // // //             </Box>
// // // //           </Box>
// // // //         </Paper>
// // // //       )}

// // // //       {/* Summary Section */}
// // // //       {isLoading ? (
// // // //         <Box className={classes.loadingContainer}>
// // // //           <CircularProgress />
// // // //         </Box>
// // // //       ) : (
// // // //         summary && (
// // // //           <Card className={classes.summaryCard}>
// // // //             <CardContent>
// // // //               <Typography variant="h6" gutterBottom>
// // // //                 Today's Cash Summary
// // // //               </Typography>
// // // //               <div className={classes.summaryItem}>
// // // //                 <WalletIcon />
// // // //                 <Typography>Opening Balance: {formatCurrency(summary.openingBalance)}</Typography>
// // // //               </div>
// // // //               <div className={classes.summaryItem}>
// // // //                 <WalletIcon />
// // // //                 <Typography>Total Sales: {formatCurrency(summary.totalSales)}</Typography>
// // // //               </div>
// // // //               <div className={classes.summaryItem}>
// // // //                 <WalletIcon />
// // // //                 <Typography>Cash In: {formatCurrency(summary.cashIn)}</Typography>
// // // //               </div>
// // // //               <div className={classes.summaryItem}>
// // // //                 <WalletIcon />
// // // //                 <Typography>Cash Out: {formatCurrency(summary.cashOut)}</Typography>
// // // //               </div>
// // // //               <div className={classes.summaryItem}>
// // // //                 <WalletIcon />
// // // //                 <Typography>Closing Balance: {formatCurrency(summary.closingBalance)}</Typography>
// // // //               </div>
// // // //             </CardContent>
// // // //           </Card>
// // // //         )
// // // //       )}

// // // //       {/* Transaction History */}
// // // //       <Paper className={classes.tableContainer}>
// // // //         <Typography variant="h6" className={classes.tableTitle}>
// // // //           Transaction History
// // // //         </Typography>
// // // //         {isLoading ? (
// // // //           <Box className={classes.loadingContainer}>
// // // //             <CircularProgress />
// // // //           </Box>
// // // //         ) : (
// // // //           <Table className={classes.table}>
// // // //             <TableHead className={classes.tableHeader}>
// // // //               <TableRow>
// // // //                 <TableCell>Date</TableCell>
// // // //                 <TableCell>Type</TableCell>
// // // //                 <TableCell>Amount</TableCell>
// // // //                 <TableCell>Notes</TableCell>
// // // //                 <TableCell>Denominations</TableCell>
// // // //               </TableRow>
// // // //             </TableHead>
// // // //             <TableBody>
// // // //               {transactions.map((tx) => (
// // // //                 <TableRow key={tx._id} className={classes.tableRow}>
// // // //                   <TableCell>{moment(tx.date).format('DD/MM/YYYY HH:mm')}</TableCell>
// // // //                   <TableCell>{tx.type}</TableCell>
// // // //                   <TableCell>{formatCurrency(tx.amount)}</TableCell>
// // // //                   <TableCell>{tx.notes || '-'}</TableCell>
// // // //                   <TableCell>
// // // //                     {Object.entries(tx.denominations).map(([denom, count]) =>
// // // //                       count > 0 ? <div key={denom}>{`${denom}: ${count}`}</div> : null
// // // //                     )}
// // // //                   </TableCell>
// // // //                 </TableRow>
// // // //               ))}
// // // //             </TableBody>
// // // //           </Table>
// // // //         )}
// // // //       </Paper>

// // // //       <Snackbar
// // // //         open={snackbar.open}
// // // //         autoHideDuration={6000}
// // // //         onClose={() => setSnackbar({ ...snackbar, open: false })}
// // // //         className={classes.snackbar}
// // // //       >
// // // //         <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
// // // //           {snackbar.message}
// // // //         </Alert>
// // // //       </Snackbar>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default CashManagement;


// // // import React, { useState, useEffect, useCallback } from 'react';
// // // import { useDispatch, useSelector } from 'react-redux';
// // // import {
// // //   createCashTransaction,
// // //   fetchCashTransactions,
// // //   closeRegister,
// // //   fetchCashSummary,
// // // } from '../../actions/cashTransactionActions';
// // // import {
// // //   Button,
// // //   TextField,
// // //   Table,
// // //   TableBody,
// // //   TableCell,
// // //   TableHead,
// // //   TableRow,
// // //   Paper,
// // //   Typography,
// // //   Grid,
// // //   Snackbar,
// // //   CircularProgress,
// // //   Card,
// // //   CardContent,
// // //   IconButton,
// // //   Box,
// // // } from '@material-ui/core';
// // // import { makeStyles } from '@material-ui/core/styles';
// // // import { Close as CloseIcon, AccountBalanceWallet as WalletIcon } from '@material-ui/icons';
// // // import moment from 'moment';
// // // import { Alert } from '@material-ui/lab';

// // // const useStyles = makeStyles((theme) => ({
// // //   root: {
// // //     padding: theme.spacing(4),
// // //     backgroundColor: '#fafafa',
// // //     marginLeft:"85px",
// // //     minHeight: '100vh',
// // //     [theme.breakpoints.down('sm')]: {
// // //       padding: theme.spacing(2),
// // //     },
// // //   },
// // //   header: {
// // //     marginBottom: theme.spacing(3),
// // //     fontWeight: 600,
// // //     color: theme.palette.primary.dark,
// // //   },
// // //   section: {
// // //     marginBottom: theme.spacing(4),
// // //   },
// // //   actionButton: {
// // //     textTransform: 'none',
// // //     fontWeight: 500,
// // //     padding: theme.spacing(1.5, 3),
// // //     borderRadius: 8,
// // //     transition: 'all 0.3s ease',
// // //     '&:hover': {
// // //       transform: 'translateY(-2px)',
// // //       boxShadow: theme.shadows[4],
// // //     },
// // //   },
// // //   closeButton: {
// // //     backgroundColor: theme.palette.error.main,
// // //     color: '#fff',
// // //     '&:hover': {
// // //       backgroundColor: theme.palette.error.dark,
// // //     },
// // //   },
// // //   formContainer: {
// // //     padding: theme.spacing(3),
// // //     borderRadius: 12,
// // //     boxShadow: theme.shadows[3],
// // //     backgroundColor: '#fff',
// // //     maxWidth: 500,
// // //     margin: '0 auto',
// // //   },
// // //   formField: {
// // //     marginBottom: theme.spacing(2),
// // //   },
// // //   denominationField: {
// // //     '& input': {
// // //       textAlign: 'right',
// // //     },
// // //   },
// // //   cancelButton: {
// // //     marginRight: theme.spacing(2),
// // //   },
// // //   summaryCard: {
// // //     borderRadius: 12,
// // //     boxShadow: theme.shadows[3],
// // //     backgroundColor: '#fff',
// // //     padding: theme.spacing(3),
// // //     marginBottom: theme.spacing(4),
// // //   },
// // //   summaryItem: {
// // //     display: 'flex',
// // //     alignItems: 'center',
// // //     marginBottom: theme.spacing(1.5),
// // //     '& svg': {
// // //       marginRight: theme.spacing(1.5),
// // //       color: theme.palette.primary.main,
// // //     },
// // //   },
// // //   tableContainer: {
// // //     borderRadius: 12,
// // //     boxShadow: theme.shadows[3],
// // //     overflowX: 'auto',
// // //   },
// // //   table: {
// // //     minWidth: 650,
// // //     [theme.breakpoints.down('sm')]: {
// // //       minWidth: 300,
// // //     },
// // //   },
// // //   tableHeader: {
// // //     backgroundColor: theme.palette.primary.light,
// // //     '& th': {
// // //       fontWeight: 600,
// // //       color: theme.palette.primary.contrastText,
// // //     },
// // //   },
// // //   tableRow: {
// // //     '&:hover': {
// // //       backgroundColor: theme.palette.action.hover,
// // //     },
// // //   },
// // //   tableTitle: {
// // //     padding: theme.spacing(2),
// // //   },
// // //   loadingContainer: {
// // //     display: 'flex',
// // //     justifyContent: 'center',
// // //     alignItems: 'center',
// // //     minHeight: 200,
// // //   },
// // //   snackbar: {
// // //     maxWidth: 400,
// // //   },
// // //   noData: {
// // //     padding: theme.spacing(2),
// // //     textAlign: 'center',
// // //     color: theme.palette.text.secondary,
// // //   },
// // // }));

// // // const CashManagement = () => {
// // //   const classes = useStyles();
// // //   const dispatch = useDispatch();
// // //   const { transactions, summary, isLoading } = useSelector((state) => state.cashTransactions);
// // //   const user = JSON.parse(localStorage.getItem('profile'));

// // //   const [openForm, setOpenForm] = useState({ type: '', open: false });
// // //   const [amount, setAmount] = useState('');
// // //   const [notes, setNotes] = useState('');
// // //   const [denominations, setDenominations] = useState({
// // //     1000: 0,
// // //     500: 0,
// // //     100: 0,
// // //     50: 0,
// // //     20: 0,
// // //   });
// // //   const [cashOutAmount, setCashOutAmount] = useState('');
// // //   const [formErrors, setFormErrors] = useState({});
// // //   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

// // //   // Fetch transactions and summary on mount and after transactions
// // //   const fetchData = useCallback(() => {
// // //     const today = moment().format('YYYY-MM-DD');
// // //     console.log('Fetching cash transactions for date:', today);
// // //     dispatch(fetchCashSummary(today));
// // //     dispatch(fetchCashTransactions(today, today)).then((action) => {
// // //       console.log('Fetched transactions:', action.payload);
// // //     });
// // //   }, [dispatch]);

// // //   useEffect(() => {
// // //     fetchData();
// // //   }, [fetchData]);

// // //   // Validate form inputs
// // //   const validateForm = () => {
// // //     const errors = {};
// // //     if (openForm.type === 'OPENING' || openForm.type === 'CASH_IN') {
// // //       const totalAmount = Object.entries(denominations).reduce(
// // //         (sum, [denom, count]) => sum + parseInt(denom) * count,
// // //         0
// // //       );
// // //       if (totalAmount <= 0) {
// // //         errors.denominations = 'Please enter at least one denomination';
// // //       }
// // //     }
// // //     if (openForm.type === 'CASH_OUT' && (!amount || parseFloat(amount) <= 0)) {
// // //       errors.amount = 'Please enter a valid amount';
// // //     }
// // //     if (openForm.type === 'CLOSING' && cashOutAmount && parseFloat(cashOutAmount) < 0) {
// // //       errors.cashOutAmount = 'Cash out amount cannot be negative';
// // //     }
// // //     setFormErrors(errors);
// // //     return Object.keys(errors).length === 0;
// // //   };

// // //   const handleOpenForm = (type) => {
// // //     setOpenForm({ type, open: true });
// // //     setAmount('');
// // //     setNotes('');
// // //     setDenominations({ 1000: 0, 500: 0, 100: 0, 50: 0, 20: 0 });
// // //     setCashOutAmount('');
// // //     setFormErrors({});
// // //   };

// // //   const handleSubmit = () => {
// // //     if (!validateForm()) return;

// // //     const totalAmount = Object.entries(denominations).reduce(
// // //       (sum, [denom, count]) => sum + parseInt(denom) * count,
// // //       0
// // //     );

// // //     const transaction = {
// // //       type: openForm.type,
// // //       amount: openForm.type === 'OPENING' || openForm.type === 'CASH_IN' ? totalAmount : parseFloat(amount),
// // //       denominations: openForm.type === 'OPENING' || openForm.type === 'CASH_IN' ? denominations : {},
// // //       notes,
// // //       creator: user?.result?._id,
// // //     };

// // //     dispatch(createCashTransaction(transaction, (success, error) => {
// // //       if (success) {
// // //         setSnackbar({ open: true, message: 'Transaction recorded successfully', severity: 'success' });
// // //         setOpenForm({ type: '', open: false });
// // //         fetchData(); // Re-fetch transactions after creating a new one
// // //       } else {
// // //         setSnackbar({ open: true, message: error || 'Error recording transaction', severity: 'error' });
// // //       }
// // //     }));
// // //   };

// // //   const handleCloseRegister = () => {
// // //     if (!validateForm()) return;

// // //     dispatch(closeRegister({ cashOutAmount: parseFloat(cashOutAmount) || 0, notes }, (success, error) => {
// // //       if (success) {
// // //         setSnackbar({ open: true, message: 'Register closed successfully', severity: 'success' });
// // //         setCashOutAmount('');
// // //         setNotes('');
// // //         setOpenForm({ type: '', open: false });
// // //         fetchData(); // Re-fetch transactions after closing register
// // //       } else {
// // //         setSnackbar({ open: true, message: error || 'Error closing register', severity: 'error' });
// // //       }
// // //     }));
// // //   };

// // //   const formatCurrency = (value) =>
// // //     `₹${Number(value || 0).toLocaleString('en-US', {
// // //       minimumFractionDigits: 2,
// // //       maximumFractionDigits: 2,
// // //     })}`;

// // //   return (
// // //     <div className={classes.root}>
// // //       <Typography variant="h4" className={classes.header}>
// // //         Cash Management
// // //       </Typography>

// // //       {/* Action Buttons */}
// // //       <Grid container spacing={2} className={classes.section}>
// // //         <Grid item xs={6} sm={3}>
// // //           <Button
// // //             variant="contained"
// // //             color="primary"
// // //             fullWidth
// // //             className={classes.actionButton}
// // //             onClick={() => handleOpenForm('OPENING')}
// // //             disabled={summary?.openingBalance > 0}
// // //           >
// // //             Open Register
// // //           </Button>
// // //         </Grid>
// // //         <Grid item xs={6} sm={3}>
// // //           <Button
// // //             variant="contained"
// // //             color="primary"
// // //             fullWidth
// // //             className={classes.actionButton}
// // //             onClick={() => handleOpenForm('CASH_IN')}
// // //           >
// // //             Cash In
// // //           </Button>
// // //         </Grid>
// // //         <Grid item xs={6} sm={3}>
// // //           <Button
// // //             variant="contained"
// // //             color="primary"
// // //             fullWidth
// // //             className={classes.actionButton}
// // //             onClick={() => handleOpenForm('CASH_OUT')}
// // //           >
// // //             Cash Out
// // //           </Button>
// // //         </Grid>
// // //         <Grid item xs={6} sm={3}>
// // //           <Button
// // //             variant="contained"
// // //             fullWidth
// // //             className={`${classes.actionButton} ${classes.closeButton}`}
// // //             onClick={() => setOpenForm({ type: 'CLOSING', open: true })}
// // //           >
// // //             Close Register
// // //           </Button>
// // //         </Grid>
// // //       </Grid>

// // //       {/* Cash Transaction Form */}
// // //       {openForm.open && (
// // //         <Paper className={classes.formContainer}>
// // //           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
// // //             <Typography variant="h6">
// // //               {openForm.type === 'OPENING'
// // //                 ? 'Open Register'
// // //                 : openForm.type === 'CASH_IN'
// // //                 ? 'Cash In'
// // //                 : openForm.type === 'CASH_OUT'
// // //                 ? 'Cash Out'
// // //                 : 'Close Register'}
// // //             </Typography>
// // //             <IconButton onClick={() => setOpenForm({ type: '', open: false })}>
// // //               <CloseIcon />
// // //             </IconButton>
// // //           </Box>
// // //           <Box>
// // //             {(openForm.type === 'OPENING' || openForm.type === 'CASH_IN') && (
// // //               <>
// // //                 {Object.keys(denominations).map((denom) => (
// // //                   <TextField
// // //                     key={denom}
// // //                     label={`${denom} Notes`}
// // //                     type="number"
// // //                     fullWidth
// // //                     className={`${classes.formField} ${classes.denominationField}`}
// // //                     value={denominations[denom]}
// // //                     onChange={(e) =>
// // //                       setDenominations({
// // //                         ...denominations,
// // //                         [denom]: parseInt(e.target.value) || 0,
// // //                       })
// // //                     }
// // //                     error={!!formErrors.denominations}
// // //                     helperText={formErrors.denominations}
// // //                   />
// // //                 ))}
// // //               </>
// // //             )}
// // //             {(openForm.type === 'CASH_OUT' || openForm.type === 'CLOSING') && (
// // //               <TextField
// // //                 label="Amount"
// // //                 type="number"
// // //                 fullWidth
// // //                 className={classes.formField}
// // //                 value={openForm.type === 'CLOSING' ? cashOutAmount : amount}
// // //                 onChange={(e) =>
// // //                   openForm.type === 'CLOSING'
// // //                     ? setCashOutAmount(e.target.value)
// // //                     : setAmount(e.target.value)
// // //                 }
// // //                 error={!!formErrors.amount || !!formErrors.cashOutAmount}
// // //                 helperText={formErrors.amount || formErrors.cashOutAmount}
// // //               />
// // //             )}
// // //             <TextField
// // //               label="Notes"
// // //               multiline
// // //               rows={4}
// // //               fullWidth
// // //               className={classes.formField}
// // //               value={notes}
// // //               onChange={(e) => setNotes(e.target.value)}
// // //             />
// // //             <Box display="flex" justifyContent="flex-end" mt={2}>
// // //               <Button
// // //                 variant="outlined"
// // //                 color="primary"
// // //                 className={classes.cancelButton}
// // //                 onClick={() => setOpenForm({ type: '', open: false })}
// // //               >
// // //                 Cancel
// // //               </Button>
// // //               <Button
// // //                 variant="contained"
// // //                 color="primary"
// // //                 onClick={openForm.type === 'CLOSING' ? handleCloseRegister : handleSubmit}
// // //               >
// // //                 Submit
// // //               </Button>
// // //             </Box>
// // //           </Box>
// // //         </Paper>
// // //       )}

// // //       {/* Summary Section */}
// // //       {isLoading ? (
// // //         <Box className={classes.loadingContainer}>
// // //           <CircularProgress />
// // //         </Box>
// // //       ) : (
// // //         summary && (
// // //           <Card className={classes.summaryCard}>
// // //             <CardContent>
// // //               <Typography variant="h6" gutterBottom>
// // //                 Today's Cash Summary
// // //               </Typography>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Opening Balance: {formatCurrency(summary.openingBalance)}</Typography>
// // //               </div>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Total Sales: {formatCurrency(summary.totalSales)}</Typography>
// // //               </div>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Cash In: {formatCurrency(summary.cashIn)}</Typography>
// // //               </div>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Cash Out: {formatCurrency(summary.cashOut)}</Typography>
// // //               </div>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Closing Balance: {formatCurrency(summary.closingBalance)}</Typography>
// // //               </div>
// // //             </CardContent>
// // //           </Card>
// // //         )
// // //       )}

// // //       {/* Transaction History */}
// // //       <Paper className={classes.tableContainer}>
// // //         <Typography variant="h6" className={classes.tableTitle}>
// // //           Transaction History
// // //         </Typography>
// // //         {isLoading ? (
// // //           <Box className={classes.loadingContainer}>
// // //             <CircularProgress />
// // //           </Box>
// // //         ) : transactions.length === 0 ? (
// // //           <Typography className={classes.noData}>No transactions found for today</Typography>
// // //         ) : (
// // //           <Table className={classes.table}>
// // //             <TableHead className={classes.tableHeader}>
// // //               <TableRow>
// // //                 <TableCell>Date</TableCell>
// // //                 <TableCell>Type</TableCell>
// // //                 <TableCell>Amount</TableCell>
// // //                 <TableCell>Notes</TableCell>
// // //                 <TableCell>Denominations</TableCell>
// // //               </TableRow>
// // //             </TableHead>
// // //             <TableBody>
// // //               {transactions.map((tx) => (
// // //                 <TableRow key={tx._id} className={classes.tableRow}>
// // //                   <TableCell>{moment(tx.date).format('DD/MM/YYYY HH:mm')}</TableCell>
// // //                   <TableCell>{tx.type}</TableCell>
// // //                   <TableCell>{formatCurrency(tx.amount)}</TableCell>
// // //                   <TableCell>{tx.notes || '-'}</TableCell>
// // //                   <TableCell>
// // //                     {Object.entries(tx.denominations).map(([denom, count]) =>
// // //                       count > 0 ? <div key={denom}>{`${denom}: ${count}`}</div> : null
// // //                     )}
// // //                   </TableCell>
// // //                 </TableRow>
// // //               ))}
// // //             </TableBody>
// // //           </Table>
// // //         )}
// // //       </Paper>

// // //       <Snackbar
// // //         open={snackbar.open}
// // //         autoHideDuration={6000}
// // //         onClose={() => setSnackbar({ ...snackbar, open: false })}
// // //         className={classes.snackbar}
// // //       >
// // //         <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
// // //           {snackbar.message}
// // //         </Alert>
// // //       </Snackbar>
// // //     </div>
// // //   );
// // // };

// // // export default CashManagement;


// // // import React, { useState, useEffect, useCallback } from 'react';
// // // import { useDispatch, useSelector } from 'react-redux';
// // // import {
// // //   createCashTransaction,
// // //   fetchCashTransactions,
// // //   closeRegister,
// // //   fetchCashSummary,
// // // } from '../../actions/cashTransactionActions';
// // // import {
// // //   MuiPickersUtilsProvider,
// // //   KeyboardDatePicker,
// // // } from "@material-ui/pickers";
// // // import DateFnsUtils from "@date-io/date-fns";
// // // import {
// // //   Button,
// // //   TextField,
// // //   Table,
// // //   TableBody,
// // //   TableCell,
// // //   TableHead,
// // //   TableRow,
// // //   Paper,
// // //   Typography,
// // //   Grid,
// // //   Snackbar,
// // //   CircularProgress,
// // //   Card,
// // //   CardContent,
// // //   IconButton,
// // //   Box,
// // // } from '@material-ui/core';
// // // import { makeStyles } from '@material-ui/core/styles';
// // // import { Close as CloseIcon, AccountBalanceWallet as WalletIcon } from '@material-ui/icons';
// // // import { Alert } from '@material-ui/lab';
// // // import moment from 'moment';
// // // import { DatePicker } from '@material-ui/pickers';

// // // const useStyles = makeStyles((theme) => ({
// // //   root: {
// // //     padding: theme.spacing(4),
// // //     backgroundColor: '#fafafa',
// // //     marginLeft: "85px",
// // //     minHeight: '100vh',
// // //     [theme.breakpoints.down('sm')]: {
// // //       padding: theme.spacing(2),
// // //     },
// // //   },
// // //   header: {
// // //     marginBottom: theme.spacing(3),
// // //     fontWeight: 600,
// // //     color: theme.palette.primary.dark,
// // //   },
// // //   section: {
// // //     marginBottom: theme.spacing(4),
// // //   },
// // //   actionButton: {
// // //     textTransform: 'none',
// // //     fontWeight: 500,
// // //     padding: theme.spacing(1.5, 3),
// // //     borderRadius: 8,
// // //     transition: 'all 0.3s ease',
// // //     '&:hover': {
// // //       transform: 'translateY(-2px)',
// // //       boxShadow: theme.shadows[4],
// // //     },
// // //   },
// // //   closeButton: {
// // //     backgroundColor: theme.palette.error.main,
// // //     color: '#fff',
// // //     '&:hover': {
// // //       backgroundColor: theme.palette.error.dark,
// // //     },
// // //   },
// // //   formContainer: {
// // //     padding: theme.spacing(3),
// // //     borderRadius: 12,
// // //     boxShadow: theme.shadows[3],
// // //     backgroundColor: '#fff',
// // //     maxWidth: 500,
// // //     margin: '0 auto',
// // //   },
// // //   formField: {
// // //     marginBottom: theme.spacing(2),
// // //   },
// // //   denominationField: {
// // //     '& input': {
// // //       textAlign: 'right',
// // //     },
// // //   },
// // //   cancelButton: {
// // //     marginRight: theme.spacing(2),
// // //   },
// // //   summaryCard: {
// // //     borderRadius: 12,
// // //     boxShadow: theme.shadows[3],
// // //     backgroundColor: '#fff',
// // //     padding: theme.spacing(3),
// // //     marginBottom: theme.spacing(4),
// // //   },
// // //   summaryItem: {
// // //     display: 'flex',
// // //     alignItems: 'center',
// // //     marginBottom: theme.spacing(1.5),
// // //     '& svg': {
// // //       marginRight: theme.spacing(1.5),
// // //       color: theme.palette.primary.main,
// // //     },
// // //   },
// // //   tableContainer: {
// // //     borderRadius: 12,
// // //     boxShadow: theme.shadows[3],
// // //     overflowX: 'auto',
// // //   },
// // //   table: {
// // //     minWidth: 650,
// // //     [theme.breakpoints.down('sm')]: {
// // //       minWidth: 300,
// // //     },
// // //   },
// // //   tableHeader: {
// // //     backgroundColor: theme.palette.primary.light,
// // //     '& th': {
// // //       fontWeight: 600,
// // //       color: theme.palette.primary.contrastText,
// // //     },
// // //   },
// // //   tableRow: {
// // //     '&:hover': {
// // //       backgroundColor: theme.palette.action.hover,
// // //     },
// // //   },
// // //   tableTitle: {
// // //     padding: theme.spacing(2),
// // //   },
// // //   loadingContainer: {
// // //     display: 'flex',
// // //     justifyContent: 'center',
// // //     alignItems: 'center',
// // //     minHeight: 200,
// // //   },
// // //   snackbar: {
// // //     maxWidth: 400,
// // //   },
// // //   noData: {
// // //     padding: theme.spacing(2),
// // //     textAlign: 'center',
// // //     color: theme.palette.text.secondary,
// // //   },
// // //   datePicker: {
// // //     marginBottom: theme.spacing(2),
// // //   },
// // // }));

// // // const CashManagement = () => {
// // //   const classes = useStyles();
// // //   const dispatch = useDispatch();
// // //   const { transactions, summary, isLoading } = useSelector((state) => state.cashTransactions);
// // //   const user = JSON.parse(localStorage.getItem('profile'));

// // //   const [openForm, setOpenForm] = useState({ type: '', open: false });
// // //   const [amount, setAmount] = useState('');
// // //   const [notes, setNotes] = useState('');
// // //   const [denominations, setDenominations] = useState({
// // //     1000: 0,
// // //     500: 0,
// // //     100: 0,
// // //     50: 0,
// // //     20: 0,
// // //   });
// // //   const [cashOutAmount, setCashOutAmount] = useState('');
// // //   const [formErrors, setFormErrors] = useState({});
// // //   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
// // //   const [selectedDate, setSelectedDate] = useState(moment().toDate());

// // //   const fetchData = useCallback(() => {
// // //     const date = moment(selectedDate).format('YYYY-MM-DD');
// // //     console.log('Frontend: Fetching cash transactions for date:', date);
// // //     dispatch(fetchCashSummary(date));
// // //     dispatch(fetchCashTransactions(date, date)).then((action) => {
// // //       console.log('Frontend: Fetched transactions:', action.payload);
// // //     });
// // //   }, [dispatch, selectedDate]);

// // //   useEffect(() => {
// // //     fetchData();
// // //   }, [fetchData]);

// // //   const validateForm = () => {
// // //     const errors = {};
// // //     if (openForm.type === 'OPENING' || openForm.type === 'CASH_IN') {
// // //       const totalAmount = Object.entries(denominations).reduce(
// // //         (sum, [denom, count]) => sum + parseInt(denom) * count,
// // //         0
// // //       );
// // //       if (totalAmount <= 0) {
// // //         errors.denominations = 'Please enter at least one denomination';
// // //       }
// // //     }
// // //     if (openForm.type === 'CASH_OUT' && (!amount || parseFloat(amount) <= 0)) {
// // //       errors.amount = 'Please enter a valid amount';
// // //     }
// // //     if (openForm.type === 'CLOSING' && cashOutAmount && parseFloat(cashOutAmount) < 0) {
// // //       errors.cashOutAmount = 'Cash out amount cannot be negative';
// // //     }
// // //     setFormErrors(errors);
// // //     return Object.keys(errors).length === 0;
// // //   };

// // //   const handleOpenForm = (type) => {
// // //     setOpenForm({ type, open: true });
// // //     setAmount('');
// // //     setNotes('');
// // //     setDenominations({ 1000: 0, 500: 0, 100: 0, 50: 0, 20: 0 });
// // //     setCashOutAmount('');
// // //     setFormErrors({});
// // //   };

// // //   const handleSubmit = () => {
// // //     if (!validateForm()) return;

// // //     const totalAmount = Object.entries(denominations).reduce(
// // //       (sum, [denom, count]) => sum + parseInt(denom) * count,
// // //       0
// // //     );

// // //     const transaction = {
// // //       type: openForm.type,
// // //       amount: openForm.type === 'OPENING' || openForm.type === 'CASH_IN' ? totalAmount : parseFloat(amount),
// // //       denominations: openForm.type === 'OPENING' || openForm.type === 'CASH_IN' ? denominations : {},
// // //       notes,
// // //       creator: user?.result?._id,
// // //     };

// // //     dispatch(createCashTransaction(transaction, (success, error) => {
// // //       if (success) {
// // //         setSnackbar({ open: true, message: 'Transaction recorded successfully', severity: 'success' });
// // //         setOpenForm({ type: '', open: false });
// // //         fetchData();
// // //       } else {
// // //         setSnackbar({ open: true, message: error || 'Error recording transaction', severity: 'error' });
// // //       }
// // //     }));
// // //   };

// // //   const handleCloseRegister = () => {
// // //     if (!validateForm()) return;

// // //     dispatch(closeRegister({ cashOutAmount: parseFloat(cashOutAmount) || 0, notes }, (success, error) => {
// // //       if (success) {
// // //         setSnackbar({ open: true, message: 'Register closed successfully', severity: 'success' });
// // //         setCashOutAmount('');
// // //         setNotes('');
// // //         setOpenForm({ type: '', open: false });
// // //         fetchData();
// // //       } else {
// // //         setSnackbar({ open: true, message: error || 'Error closing register', severity: 'error' });
// // //       }
// // //     }));
// // //   };

// // //   const formatCurrency = (value) =>
// // //     `₹${Number(value || 0).toLocaleString('en-US', {
// // //       minimumFractionDigits: 2,
// // //       maximumFractionDigits: 2,
// // //     })}`;

// // //   return (
// // //     <div className={classes.root}>
// // //       <Typography variant="h4" className={classes.header}>
// // //         Cash Management
// // //       </Typography>

// // //       {/* Date Picker */}
// // //       {/* <Box className={classes.datePicker}>
// // //         <DatePicker
// // //           label="Select Date"
// // //           value={selectedDate}
// // //           onChange={(date) => setSelectedDate(date)}
// // //           renderInput={(props) => <TextField {...props} />}
// // //         />
// // //       </Box> */}

// // //       {/* Action Buttons */}
// // //       <Grid container spacing={2} className={classes.section}>
// // //         <Grid item xs={6} sm={3}>
// // //           <Button
// // //             variant="contained"
// // //             color="primary"
// // //             fullWidth
// // //             className={classes.actionButton}
// // //             onClick={() => handleOpenForm('OPENING')}
// // //             disabled={summary?.openingBalance > 0 || isLoading}
// // //           >
// // //             Open Register
// // //           </Button>
// // //         </Grid>
// // //         <Grid item xs={6} sm={3}>
// // //           <Button
// // //             variant="contained"
// // //             color="primary"
// // //             fullWidth
// // //             className={classes.actionButton}
// // //             onClick={() => handleOpenForm('CASH_IN')}
// // //             disabled={isLoading}
// // //           >
// // //             Cash In
// // //           </Button>
// // //         </Grid>
// // //         <Grid item xs={6} sm={3}>
// // //           <Button
// // //             variant="contained"
// // //             color="primary"
// // //             fullWidth
// // //             className={classes.actionButton}
// // //             onClick={() => handleOpenForm('CASH_OUT')}
// // //             disabled={isLoading}
// // //           >
// // //             Cash Out
// // //           </Button>
// // //         </Grid>
// // //         <Grid item xs={6} sm={3}>
// // //           <Button
// // //             variant="contained"
// // //             fullWidth
// // //             className={`${classes.actionButton} ${classes.closeButton}`}
// // //             onClick={() => setOpenForm({ type: 'CLOSING', open: true })}
// // //             disabled={isLoading}
// // //           >
// // //             Close Register
// // //           </Button>
// // //         </Grid>
// // //       </Grid>

// // //       {/* Cash Transaction Form */}
// // //       {openForm.open && (
// // //         <Paper className={classes.formContainer}>
// // //           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
// // //             <Typography variant="h6">
// // //               {openForm.type === 'OPENING'
// // //                 ? 'Open Register'
// // //                 : openForm.type === 'CASH_IN'
// // //                 ? 'Cash In'
// // //                 : openForm.type === 'CASH_OUT'
// // //                 ? 'Cash Out'
// // //                 : 'Close Register'}
// // //             </Typography>
// // //             <IconButton onClick={() => setOpenForm({ type: '', open: false })}>
// // //               <CloseIcon />
// // //             </IconButton>
// // //           </Box>
// // //           <Box>
// // //             {(openForm.type === 'OPENING' || openForm.type === 'CASH_IN') && (
// // //               <>
// // //                 {Object.keys(denominations).map((denom) => (
// // //                   <TextField
// // //                     key={denom}
// // //                     label={`${denom} Notes`}
// // //                     type="number"
// // //                     fullWidth
// // //                     className={`${classes.formField} ${classes.denominationField}`}
// // //                     value={denominations[denom]}
// // //                     onChange={(e) =>
// // //                       setDenominations({
// // //                         ...denominations,
// // //                         [denom]: parseInt(e.target.value) || 0,
// // //                       })
// // //                     }
// // //                     error={!!formErrors.denominations}
// // //                     helperText={formErrors.denominations}
// // //                   />
// // //                 ))}
// // //               </>
// // //             )}
// // //             {(openForm.type === 'CASH_OUT' || openForm.type === 'CLOSING') && (
// // //               <TextField
// // //                 label="Amount"
// // //                 type="number"
// // //                 fullWidth
// // //                 className={classes.formField}
// // //                 value={openForm.type === 'CLOSING' ? cashOutAmount : amount}
// // //                 onChange={(e) =>
// // //                   openForm.type === 'CLOSING'
// // //                     ? setCashOutAmount(e.target.value)
// // //                     : setAmount(e.target.value)
// // //                 }
// // //                 error={!!formErrors.amount || !!formErrors.cashOutAmount}
// // //                 helperText={formErrors.amount || formErrors.cashOutAmount}
// // //               />
// // //             )}
// // //             <TextField
// // //               label="Notes"
// // //               multiline
// // //               rows={4}
// // //               fullWidth
// // //               className={classes.formField}
// // //               value={notes}
// // //               onChange={(e) => setNotes(e.target.value)}
// // //             />
// // //             <Box display="flex" justifyContent="flex-end" mt={2}>
// // //               <Button
// // //                 variant="outlined"
// // //                 color="primary"
// // //                 className={classes.cancelButton}
// // //                 onClick={() => setOpenForm({ type: '', open: false })}
// // //                 disabled={isLoading}
// // //               >
// // //                 Cancel
// // //               </Button>
// // //               <Button
// // //                 variant="contained"
// // //                 color="primary"
// // //                 onClick={openForm.type === 'CLOSING' ? handleCloseRegister : handleSubmit}
// // //                 disabled={isLoading}
// // //               >
// // //                 {isLoading ? <CircularProgress size={24} /> : 'Submit'}
// // //               </Button>
// // //             </Box>
// // //           </Box>
// // //         </Paper>
// // //       )}

// // //       {/* Summary Section */}
// // //       {isLoading ? (
// // //         <Box className={classes.loadingContainer}>
// // //           <CircularProgress />
// // //         </Box>
// // //       ) : (
// // //         summary && (
// // //           <Card className={classes.summaryCard}>
// // //             <CardContent>
// // //               <Typography variant="h6" gutterBottom>
// // //                 Cash Summary for {moment(selectedDate).format('DD/MM/YYYY')}
// // //               </Typography>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Opening Balance: {formatCurrency(summary.openingBalance)}</Typography>
// // //               </div>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Total Sales: {formatCurrency(summary.totalSales)}</Typography>
// // //               </div>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Cash In: {formatCurrency(summary.cashIn)}</Typography>
// // //               </div>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Cash Out: {formatCurrency(summary.cashOut)}</Typography>
// // //               </div>
// // //               <div className={classes.summaryItem}>
// // //                 <WalletIcon />
// // //                 <Typography>Closing Balance: {formatCurrency(summary.closingBalance)}</Typography>
// // //               </div>
// // //             </CardContent>
// // //           </Card>
// // //         )
// // //       )}

// // //       {/* Transaction History */}
// // //       <Paper className={classes.tableContainer}>
// // //         <Typography variant="h6" className={classes.tableTitle}>
// // //           Transaction History
// // //         </Typography>
// // //         {isLoading ? (
// // //           <Box className={classes.loadingContainer}>
// // //             <CircularProgress />
// // //           </Box>
// // //         ) : transactions.length === 0 ? (
// // //           <Typography className={classes.noData}>No transactions found for this date</Typography>
// // //         ) : (
// // //           <Table className={classes.table}>
// // //             <TableHead className={classes.tableHeader}>
// // //               <TableRow>
// // //                 <TableCell>Date</TableCell>
// // //                 <TableCell>Type</TableCell>
// // //                 <TableCell>Amount</TableCell>
// // //                 <TableCell>Notes</TableCell>
// // //                 <TableCell>Denominations</TableCell>
// // //               </TableRow>
// // //             </TableHead>
// // //             <TableBody>
// // //               {transactions.map((tx) => {
// // //                 const formattedDate = moment(tx.date).format('DD/MM/YYYY HH:mm:ss');
// // //                 console.log('Frontend: Displaying transaction:', {
// // //                   _id: tx._id,
// // //                   type: tx.type,
// // //                   date: tx.date,
// // //                   formattedDate,
// // //                 });
// // //                 return (
// // //                   <TableRow key={tx._id} className={classes.tableRow}>
// // //                     <TableCell>{formattedDate}</TableCell>
// // //                     <TableCell>{tx.type}</TableCell>
// // //                     <TableCell>{formatCurrency(tx.amount)}</TableCell>
// // //                     <TableCell>{tx.notes || '-'}</TableCell>
// // //                     <TableCell>
// // //                       {Object.entries(tx.denominations).map(([denom, count]) =>
// // //                         count > 0 ? <div key={denom}>{`${denom}: ${count}`}</div> : null
// // //                       )}
// // //                     </TableCell>
// // //                   </TableRow>
// // //                 );
// // //               })}
// // //             </TableBody>
// // //           </Table>
// // //         )}
// // //       </Paper>

// // //       <Snackbar
// // //         open={snackbar.open}
// // //         autoHideDuration={6000}
// // //         onClose={() => setSnackbar({ ...snackbar, open: false })}
// // //         className={classes.snackbar}
// // //       >
// // //         <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
// // //           {snackbar.message}
// // //         </Alert>
// // //       </Snackbar>
// // //     </div>
// // //   );
// // // };

// // // export default CashManagement;


// // import React, { useState, useEffect, useCallback } from 'react';
// // import { useDispatch, useSelector } from 'react-redux';
// // import {
// //   createCashTransaction,
// //   fetchCashTransactions,
// //   closeRegister,
// //   fetchCashSummary,
// // } from '../../actions/cashTransactionActions';
// // import {
// //   Button,
// //   TextField,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Typography,
// //   Grid,
// //   Paper,
// //   Divider,
// //   IconButton,
// //   Box,
// //   InputAdornment,
// // } from '@material-ui/core';
// // import { makeStyles } from '@material-ui/core/styles';
// // import { Close as CloseIcon, AttachMoney as MoneyIcon, Note as NoteIcon } from '@material-ui/icons';
// // import moment from 'moment';

// // const useStyles = makeStyles((theme) => ({
// //   root: {
// //     padding: theme.spacing(2),
// //     backgroundColor: '#f5f5f5',
// //     minHeight: '100vh',
// //     marginLeft:"85px"

// //   },
// //   header: {
// //     padding: theme.spacing(2),
// //     backgroundColor: '#fff',
// //     borderRadius: 4,
// //     marginBottom: theme.spacing(2),
// //     boxShadow: '0 1px 2px 0 rgba(0,0,0,0.1)',
// //   },
// //   actionButton: {
// //     margin: theme.spacing(0.5),
// //     textTransform: 'none',
// //     borderRadius: 4,
// //     padding: theme.spacing(1, 2),
// //     boxShadow: 'none',
// //     '&.cash-in': {
// //       backgroundColor: '#e8f5e9',
// //       color: '#2e7d32',
// //       '&:hover': {
// //         backgroundColor: '#c8e6c9',
// //       },
// //     },
// //     '&.cash-out': {
// //       backgroundColor: '#ffebee',
// //       color: '#c62828',
// //       '&:hover': {
// //         backgroundColor: '#ffcdd2',
// //       },
// //     },
// //     '&.close': {
// //       backgroundColor: '#e3f2fd',
// //       color: '#1565c0',
// //       '&:hover': {
// //         backgroundColor: '#bbdefb',
// //       },
// //     },
// //   },
// //   dialog: {
// //     '& .MuiDialog-paper': {
// //       width: '400px',
// //       maxWidth: '100%',
// //     },
// //   },
// //   dialogTitle: {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     padding: theme.spacing(2),
// //     borderBottom: '1px solid #e0e0e0',
// //   },
// //   dialogContent: {
// //     padding: theme.spacing(3),
// //   },
// //   denominationRow: {
// //     display: 'flex',
// //     alignItems: 'center',
// //     marginBottom: theme.spacing(2),
// //     '& .label': {
// //       width: '100px',
// //       color: theme.palette.text.secondary,
// //     },
// //     '& .input': {
// //       flex: 1,
// //     },
// //   },
// //   totalRow: {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     padding: theme.spacing(2),
// //     backgroundColor: '#f5f5f5',
// //     borderRadius: 4,
// //     marginTop: theme.spacing(2),
// //   },
// //   summaryCard: {
// //     padding: theme.spacing(2),
// //     backgroundColor: '#fff',
// //     borderRadius: 4,
// //     marginBottom: theme.spacing(2),
// //     boxShadow: '0 1px 2px 0 rgba(0,0,0,0.1)',
// //   },
// //   summaryItem: {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     marginBottom: theme.spacing(1),
// //   },
// //   transactionItem: {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     padding: theme.spacing(1.5, 2),
// //     borderBottom: '1px solid #f0f0f0',
// //     '&:last-child': {
// //       borderBottom: 'none',
// //     },
// //   },
// //   transactionAmount: {
// //     fontWeight: 500,
// //     '&.cash-in': {
// //       color: '#2e7d32',
// //     },
// //     '&.cash-out': {
// //       color: '#c62828',
// //     },
// //   },
// // }));

// // const CashManagement = () => {
// //   const classes = useStyles();
// //   const dispatch = useDispatch();
// //   const { transactions, summary, isLoading } = useSelector((state) => state.cashTransactions);
// //   const user = JSON.parse(localStorage.getItem('profile'));

// //   const [openDialog, setOpenDialog] = useState(null);
// //   const [amount, setAmount] = useState('');
// //   const [notes, setNotes] = useState('');
// //   const [denominations, setDenominations] = useState({
// //     1000: 0,
// //     500: 0,
// //     100: 0,
// //     50: 0,
// //     20: 0,
// //     10: 0,
// //     5: 0,
// //     2: 0,
// //     1: 0,
// //   });
// //   const [formErrors, setFormErrors] = useState({});

// //   const fetchData = useCallback(() => {
// //     const today = moment().format('YYYY-MM-DD');
// //     dispatch(fetchCashSummary(today));
// //     dispatch(fetchCashTransactions(today, today));
// //   }, [dispatch]);

// //   useEffect(() => {
// //     fetchData();
// //   }, [fetchData]);

// //   const validateForm = () => {
// //     const errors = {};
// //     if (openDialog === 'OPENING' || openDialog === 'CASH_IN') {
// //       const totalAmount = Object.entries(denominations).reduce(
// //         (sum, [denom, count]) => sum + parseInt(denom) * count,
// //         0
// //       );
// //       if (totalAmount <= 0) {
// //         errors.denominations = 'Please enter at least one denomination';
// //       }
// //     }
// //     if (openDialog === 'CASH_OUT' && (!amount || parseFloat(amount) <= 0)) {
// //       errors.amount = 'Please enter a valid amount';
// //     }
// //     setFormErrors(errors);
// //     return Object.keys(errors).length === 0;
// //   };

// //   const handleOpenDialog = (type) => {
// //     setOpenDialog(type);
// //     setAmount('');
// //     setNotes('');
// //     setDenominations({
// //       1000: 0,
// //       500: 0,
// //       100: 0,
// //       50: 0,
// //       20: 0,
// //       10: 0,
// //       5: 0,
// //       2: 0,
// //       1: 0,
// //     });
// //     setFormErrors({});
// //   };

// //   const handleSubmit = () => {
// //     if (!validateForm()) return;

// //     const totalAmount = Object.entries(denominations).reduce(
// //       (sum, [denom, count]) => sum + parseInt(denom) * count,
// //       0
// //     );

// //     const transaction = {
// //       type: openDialog,
// //       amount: openDialog === 'OPENING' || openDialog === 'CASH_IN' ? totalAmount : parseFloat(amount),
// //       denominations: openDialog === 'OPENING' || openDialog === 'CASH_IN' ? denominations : {},
// //       notes,
// //       creator: user?.result?._id,
// //     };

// //     dispatch(createCashTransaction(transaction, (success) => {
// //       if (success) {
// //         setOpenDialog(null);
// //         fetchData();
// //       }
// //     }));
// //   };

// //   const handleCloseRegister = () => {
// //     if (!validateForm()) return;

// //     dispatch(closeRegister({ cashOutAmount: parseFloat(amount) || 0, notes }, (success) => {
// //       if (success) {
// //         setOpenDialog(null);
// //         fetchData();
// //       }
// //     }));
// //   };

// //   const formatCurrency = (value) =>
// //     new Intl.NumberFormat('en-US', {
// //       style: 'currency',
// //       currency: 'USD',
// //       minimumFractionDigits: 2,
// //     }).format(value || 0);

// //   const calculateTotal = () => {
// //     return Object.entries(denominations).reduce(
// //       (sum, [denom, count]) => sum + parseInt(denom) * count,
// //       0
// //     );
// //   };

// //   return (
// //     <div className={classes.root}>
// //       <Paper className={classes.header}>
// //         <Typography variant="h6">Cash Management</Typography>
// //       </Paper>

// //       <Grid container spacing={2}>
// //         <Grid item xs={12} md={8}>
// //           <Paper className={classes.summaryCard}>
// //             <Typography variant="subtitle1" gutterBottom>
// //               Quick Actions
// //             </Typography>
// //             <Divider style={{ marginBottom: 16 }} />
// //             <Box display="flex" flexWrap="wrap">
// //               <Button
// //                 variant="contained"
// //                 className={`${classes.actionButton} cash-in`}
// //                 startIcon={<MoneyIcon />}
// //                 onClick={() => handleOpenDialog('CASH_IN')}
// //               >
// //                 Cash In
// //               </Button>
// //               <Button
// //                 variant="contained"
// //                 className={`${classes.actionButton} cash-out`}
// //                 startIcon={<MoneyIcon />}
// //                 onClick={() => handleOpenDialog('CASH_OUT')}
// //               >
// //                 Cash Out
// //               </Button>
// //               <Button
// //                 variant="contained"
// //                 className={`${classes.actionButton} close`}
// //                 startIcon={<MoneyIcon />}
// //                 onClick={() => handleOpenDialog('CLOSING')}
// //               >
// //                 Close Register
// //               </Button>
// //             </Box>
// //           </Paper>

// //           <Paper className={classes.summaryCard}>
// //             <Typography variant="subtitle1" gutterBottom>
// //               Today's Transactions
// //             </Typography>
// //             <Divider style={{ marginBottom: 16 }} />
// //             {isLoading ? (
// //               <Box display="flex" justifyContent="center" py={4}>
// //                 <Typography>Loading...</Typography>
// //               </Box>
// //             ) : transactions.length === 0 ? (
// //               <Typography color="textSecondary" align="center" py={4}>
// //                 No transactions today
// //               </Typography>
// //             ) : (
// //               <Box>
// //                 {transactions.map((tx) => (
// //                   <Box key={tx._id} className={classes.transactionItem}>
// //                     <Box>
// //                       <Typography variant="body2">
// //                         {moment(tx.date).format('h:mm A')}
// //                       </Typography>
// //                       <Typography variant="caption" color="textSecondary">
// //                         {tx.type === 'CASH_IN' ? 'Cash In' : 
// //                          tx.type === 'CASH_OUT' ? 'Cash Out' : 
// //                          tx.type === 'OPENING' ? 'Opening Balance' : 'Closing Balance'}
// //                       </Typography>
// //                     </Box>
// //                     <Typography 
// //                       className={`${classes.transactionAmount} ${
// //                         tx.type === 'CASH_IN' || tx.type === 'OPENING' ? 'cash-in' : 'cash-out'
// //                       }`}
// //                     >
// //                       {formatCurrency(tx.amount)}
// //                     </Typography>
// //                   </Box>
// //                 ))}
// //               </Box>
// //             )}
// //           </Paper>
// //         </Grid>

// //         <Grid item xs={12} md={4}>
// //           <Paper className={classes.summaryCard}>
// //             <Typography variant="subtitle1" gutterBottom>
// //               Cash Summary
// //             </Typography>
// //             <Divider style={{ marginBottom: 16 }} />
// //             {summary && (
// //               <Box>
// //                 <Box className={classes.summaryItem}>
// //                   <Typography variant="body2">Opening Balance:</Typography>
// //                   <Typography>{formatCurrency(summary.openingBalance)}</Typography>
// //                 </Box>
// //                 <Box className={classes.summaryItem}>
// //                   <Typography variant="body2">Total Sales:</Typography>
// //                   <Typography>{formatCurrency(summary.totalSales)}</Typography>
// //                 </Box>
// //                 <Box className={classes.summaryItem}>
// //                   <Typography variant="body2">Cash In:</Typography>
// //                   <Typography style={{ color: '#2e7d32' }}>
// //                     {formatCurrency(summary.cashIn)}
// //                   </Typography>
// //                 </Box>
// //                 <Box className={classes.summaryItem}>
// //                   <Typography variant="body2">Cash Out:</Typography>
// //                   <Typography style={{ color: '#c62828' }}>
// //                     {formatCurrency(summary.cashOut)}
// //                   </Typography>
// //                 </Box>
// //                 <Divider style={{ margin: '16px 0' }} />
// //                 <Box className={classes.summaryItem}>
// //                   <Typography variant="body1" style={{ fontWeight: 500 }}>
// //                     Closing Balance:
// //                   </Typography>
// //                   <Typography variant="body1" style={{ fontWeight: 500 }}>
// //                     {formatCurrency(summary.closingBalance)}
// //                   </Typography>
// //                 </Box>
// //               </Box>
// //             )}
// //           </Paper>
// //         </Grid>
// //       </Grid>

// //       {/* Cash In/Out Dialog */}
// //       <Dialog open={!!openDialog} onClose={() => setOpenDialog(null)} className={classes.dialog}>
// //         <Box className={classes.dialogTitle}>
// //           <Typography variant="h6">
// //             {openDialog === 'OPENING'
// //               ? 'Open Register'
// //               : openDialog === 'CASH_IN'
// //               ? 'Cash In'
// //               : openDialog === 'CASH_OUT'
// //               ? 'Cash Out'
// //               : 'Close Register'}
// //           </Typography>
// //           <IconButton onClick={() => setOpenDialog(null)}>
// //             <CloseIcon />
// //           </IconButton>
// //         </Box>
// //         <DialogContent className={classes.dialogContent}>
// //           {(openDialog === 'OPENING' || openDialog === 'CASH_IN') && (
// //             <>
// //               {Object.entries({
// //                 1000: '1000',
// //                 500: '500',
// //                 100: '100',
// //                 50: '50',
// //                 20: '20',
// //                 10: '10',
// //                 5: '5',
// //                 2: '2',
// //                 1: '1',
// //               }).map(([key, label]) => (
// //                 <Box key={key} className={classes.denominationRow}>
// //                   <Typography variant="body2" className="label">
// //                     {label}:
// //                   </Typography>
// //                   <TextField
// //                     type="number"
// //                     variant="outlined"
// //                     size="small"
// //                     className="input"
// //                     value={denominations[key]}
// //                     onChange={(e) =>
// //                       setDenominations({
// //                         ...denominations,
// //                         [key]: parseInt(e.target.value) || 0,
// //                       })
// //                     }
// //                     InputProps={{
// //                       startAdornment: <InputAdornment position="start">×</InputAdornment>,
// //                     }}
// //                   />
// //                 </Box>
// //               ))}
// //               <Box className={classes.totalRow}>
// //                 <Typography variant="body2">Total:</Typography>
// //                 <Typography variant="body1" style={{ fontWeight: 500 }}>
// //                   {formatCurrency(calculateTotal())}
// //                 </Typography>
// //               </Box>
// //             </>
// //           )}
// //           {(openDialog === 'CASH_OUT' || openDialog === 'CLOSING') && (
// //             <TextField
// //               label="Amount"
// //               type="number"
// //               fullWidth
// //               variant="outlined"
// //               value={amount}
// //               onChange={(e) => setAmount(e.target.value)}
// //               error={!!formErrors.amount}
// //               helperText={formErrors.amount}
// //               InputProps={{
// //                 startAdornment: <InputAdornment position="start">$</InputAdornment>,
// //               }}
// //             />
// //           )}
// //           <TextField
// //             label="Reason"
// //             fullWidth
// //             variant="outlined"
// //             margin="normal"
// //             multiline
// //             rows={3}
// //             value={notes}
// //             onChange={(e) => setNotes(e.target.value)}
// //             InputProps={{
// //               startAdornment: (
// //                 <InputAdornment position="start">
// //                   <NoteIcon color="action" />
// //                 </InputAdornment>
// //               ),
// //             }}
// //           />
// //         </DialogContent>
// //         <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
// //           <Button onClick={() => setOpenDialog(null)} style={{ marginRight: 8 }}>
// //             Discard
// //           </Button>
// //           <Button
// //             variant="contained"
// //             color="primary"
// //             onClick={openDialog === 'CLOSING' ? handleCloseRegister : handleSubmit}
// //           >
// //             Confirm
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
// //     </div>
// //   );
// // };

// // export default CashManagement;





// import React, { useState, useEffect, useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   createCashTransaction,
//   fetchCashTransactions,
//   closeRegister,
//   fetchCashSummary,
// } from '../../actions/cashTransactionActions';
// import {
//   Button,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Typography,
//   Grid,
//   Paper,
//   Divider,
//   IconButton,
//   Box,
//   InputAdornment,
//   Tabs,
//   Tab,
//   Table,
//   TableBody,
//   TableCell,
//   TableRow,
// } from '@material-ui/core';
// import { makeStyles } from '@material-ui/core/styles';
// import { Close as CloseIcon, AttachMoney as MoneyIcon, Note as NoteIcon } from '@material-ui/icons';
// import moment from 'moment';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     padding: theme.spacing(2),
//     backgroundColor: '#f5f5f5',
//     minHeight: '100vh',
//     marginLeft: "85px"
//   },
//   header: {
//     padding: theme.spacing(2),
//     backgroundColor: '#fff',
//     borderRadius: 4,
//     marginBottom: theme.spacing(2),
//     boxShadow: '0 1px 2px 0 rgba(0,0,0,0.1)',
//   },
//   actionButton: {
//     margin: theme.spacing(0.5),
//     textTransform: 'none',
//     borderRadius: 4,
//     padding: theme.spacing(1, 2),
//     boxShadow: 'none',
//     '&.cash-in': {
//       backgroundColor: '#e8f5e9',
//       color: '#2e7d32',
//       '&:hover': {
//         backgroundColor: '#c8e6c9',
//       },
//     },
//     '&.cash-out': {
//       backgroundColor: '#ffebee',
//       color: '#c62828',
//       '&:hover': {
//         backgroundColor: '#ffcdd2',
//       },
//     },
//     '&.close': {
//       backgroundColor: '#e3f2fd',
//       color: '#1565c0',
//       '&:hover': {
//         backgroundColor: '#bbdefb',
//       },
//     },
//   },
//   dialog: {
//     '& .MuiDialog-paper': {
//       width: '400px',
//       maxWidth: '100%',
//     },
//   },
//   dialogTitle: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: theme.spacing(2),
//     borderBottom: '1px solid #e0e0e0',
//   },
//   dialogContent: {
//     padding: theme.spacing(3),
//   },
//   denominationRow: {
//     display: 'flex',
//     alignItems: 'center',
//     marginBottom: theme.spacing(2),
//     '& .label': {
//       width: '100px',
//       color: theme.palette.text.secondary,
//     },
//     '& .input': {
//       flex: 1,
//     },
//   },
//   totalRow: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: theme.spacing(2),
//     backgroundColor: '#f5f5f5',
//     borderRadius: 4,
//     marginTop: theme.spacing(2),
//   },
//   summaryCard: {
//     padding: theme.spacing(2),
//     backgroundColor: '#fff',
//     borderRadius: 4,
//     marginBottom: theme.spacing(2),
//     boxShadow: '0 1px 2px 0 rgba(0,0,0,0.1)',
//   },
//   summaryItem: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     marginBottom: theme.spacing(1),
//   },
//   transactionItem: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     padding: theme.spacing(1.5, 2),
//     borderBottom: '1px solid #f0f0f0',
//     '&:last-child': {
//       borderBottom: 'none',
//     },
//   },
//   transactionAmount: {
//     fontWeight: 500,
//     '&.cash-in': {
//       color: '#2e7d32',
//     },
//     '&.cash-out': {
//       color: '#c62828',
//     },
//   },
//   tabContainer: {
//     marginBottom: theme.spacing(2),
//   },
//   currencyButton: {
//     marginRight: theme.spacing(1),
//     marginBottom: theme.spacing(1),
//   },
//   summaryTable: {
//     marginBottom: theme.spacing(2),
//     '& .MuiTableCell-root': {
//       borderBottom: 'none',
//       padding: theme.spacing(1),
//     },
//     '& .MuiTableCell-head': {
//       fontWeight: 'bold',
//     },
//   },
// }));

// const CashManagement = () => {
//   const classes = useStyles();
//   const dispatch = useDispatch();
//   const { transactions, summary, isLoading } = useSelector((state) => state.cashTransactions);
//   const user = JSON.parse(localStorage.getItem('profile'));

//   const [openDialog, setOpenDialog] = useState(null);
//   const [amount, setAmount] = useState('');
//   const [notes, setNotes] = useState('');
//   const [denominations, setDenominations] = useState({
//     500: 0,
//     200: 0,
//     100: 0,
//     50: 0,
//     20: 0,
//     10: 0,
//     5: 0,
//     2: 0,
//     1: 0,
//   });
//   const [formErrors, setFormErrors] = useState({});
//   const [cashInOutTab, setCashInOutTab] = useState('CASH_IN');
//   const [showDenominationsDialog, setShowDenominationsDialog] = useState(false);

//   const fetchData = useCallback(() => {
//     const today = moment().format('YYYY-MM-DD');
//     dispatch(fetchCashSummary(today));
//     dispatch(fetchCashTransactions(today, today));
//   }, [dispatch]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const validateForm = () => {
//     const errors = {};
//     if (openDialog === 'OPENING' || (openDialog === 'CASH_IN_OUT' && cashInOutTab === 'CASH_IN')) {
//       const totalAmount = Object.entries(denominations).reduce(
//         (sum, [denom, count]) => sum + parseInt(denom) * count,
//         0
//       );
//       if (totalAmount <= 0) {
//         errors.denominations = 'Please enter at least one denomination';
//       }
//     }
//     if ((openDialog === 'CASH_IN_OUT' && cashInOutTab === 'CASH_OUT') && (!amount || parseFloat(amount) <= 0)) {
//       errors.amount = 'Please enter a valid amount';
//     }
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleOpenDialog = (type) => {
//     setOpenDialog(type);
//     setAmount('');
//     setNotes('');
//     setDenominations({
//       500: 0,
//       200: 0,
//       100: 0,
//       50: 0,
//       20: 0,
//       10: 0,
//       5: 0,
//       2: 0,
//       1: 0,
//     });
//     setFormErrors({});
//     if (type === 'CASH_IN_OUT') {
//       setCashInOutTab('CASH_IN');
//     }
//   };

//   const handleSubmit = () => {
//     if (!validateForm()) return;

//     const totalAmount = Object.entries(denominations).reduce(
//       (sum, [denom, count]) => sum + parseInt(denom) * count,
//       0
//     );

//     const transaction = {
//       type: openDialog === 'CASH_IN_OUT' ? cashInOutTab : openDialog,
//       amount: openDialog === 'OPENING' || (openDialog === 'CASH_IN_OUT' && cashInOutTab === 'CASH_IN') 
//         ? totalAmount 
//         : parseFloat(amount),
//       denominations: openDialog === 'OPENING' || (openDialog === 'CASH_IN_OUT' && cashInOutTab === 'CASH_IN') 
//         ? denominations 
//         : {},
//       notes,
//       creator: user?.result?._id,
//     };

//     dispatch(createCashTransaction(transaction, (success) => {
//       if (success) {
//         setOpenDialog(null);
//         setShowDenominationsDialog(false);
//         fetchData();
//       }
//     }));
//   };

//   const handleCloseRegister = () => {
//     if (!validateForm()) return;

//     dispatch(closeRegister({ cashOutAmount: parseFloat(amount) || 0, notes }, (success) => {
//       if (success) {
//         setOpenDialog(null);
//         fetchData();
//       }
//     }));
//   };

//   const formatCurrency = (value) =>
//     new Intl.NumberFormat('th-TH', {
//       style: 'currency',
//       currency: 'THB',
//       minimumFractionDigits: 2,
//     }).format(value || 0).replace('THB', '₹');

//   const calculateTotal = () => {
//     return Object.entries(denominations).reduce(
//       (sum, [denom, count]) => sum + parseInt(denom) * count,
//       0
//     );
//   };

//   const handleDenominationChange = (denomination, value) => {
//     setDenominations({
//       ...denominations,
//       [denomination]: parseInt(value) || 0,
//     });
//   };

//   return (
//     <div className={classes.root}>
//       <Paper className={classes.header}>
//         <Typography variant="h6">Cash Management</Typography>
//       </Paper>

//       <Grid container spacing={2}>
//         <Grid item xs={12} md={8}>
//           <Paper className={classes.summaryCard}>
//             <Typography variant="subtitle1" gutterBottom>
//               Quick Actions
//             </Typography>
//             <Divider style={{ marginBottom: 16 }} />
//             <Box display="flex" flexWrap="wrap">
//               <Button
//                 variant="contained"
//                 className={`${classes.actionButton} cash-in`}
//                 startIcon={<MoneyIcon />}
//                 onClick={() => handleOpenDialog('CASH_IN_OUT')}
//               >
//                 Cash In/Out
//               </Button>
//               <Button
//                 variant="contained"
//                 className={`${classes.actionButton} close`}
//                 startIcon={<MoneyIcon />}
//                 onClick={() => handleOpenDialog('CLOSING')}
//               >
//                 Close Register
//               </Button>
//               <Button
//                 variant="contained"
//                 className={`${classes.actionButton}`}
//                 startIcon={<MoneyIcon />}
//                 onClick={() => handleOpenDialog('OPENING')}
//               >
//                 Opening Control
//               </Button>
//             </Box>
//           </Paper>

//           <Paper className={classes.summaryCard}>
//             <Typography variant="subtitle1" gutterBottom>
//               Today's Transactions
//             </Typography>
//             <Divider style={{ marginBottom: 16 }} />
//             {isLoading ? (
//               <Box display="flex" justifyContent="center" py={4}>
//                 <Typography>Loading...</Typography>
//               </Box>
//             ) : transactions.length === 0 ? (
//               <Typography color="textSecondary" align="center" py={4}>
//                 No transactions today
//               </Typography>
//             ) : (
//               <Box>
//                 {transactions.map((tx) => (
//                   <Box key={tx._id} className={classes.transactionItem}>
//                     <Box>
//                       <Typography variant="body2">
//                         {moment(tx.date).format('h:mm A')}
//                       </Typography>
//                       <Typography variant="caption" color="textSecondary">
//                         {tx.type === 'CASH_IN' ? 'Cash In' : 
//                          tx.type === 'CASH_OUT' ? 'Cash Out' : 
//                          tx.type === 'OPENING' ? 'Opening Balance' : 'Closing Balance'}
//                       </Typography>
//                     </Box>
//                     <Typography 
//                       className={`${classes.transactionAmount} ${
//                         tx.type === 'CASH_IN' || tx.type === 'OPENING' ? 'cash-in' : 'cash-out'
//                       }`}
//                     >
//                       {formatCurrency(tx.amount)}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>
//             )}
//           </Paper>
//         </Grid>

//         <Grid item xs={12} md={4}>
//           <Paper className={classes.summaryCard}>
//             <Typography variant="subtitle1" gutterBottom>
//               Cash Summary
//             </Typography>
//             <Divider style={{ marginBottom: 16 }} />
//             {summary && (
//               <Box>
//                 <Box className={classes.summaryItem}>
//                   <Typography variant="body2">Opening Balance:</Typography>
//                   <Typography>{formatCurrency(summary.openingBalance)}</Typography>
//                 </Box>
//                 <Box className={classes.summaryItem}>
//                   <Typography variant="body2">Total Sales:</Typography>
//                   <Typography>{formatCurrency(summary.totalSales)}</Typography>
//                 </Box>
//                 <Box className={classes.summaryItem}>
//                   <Typography variant="body2">Cash In:</Typography>
//                   <Typography style={{ color: '#2e7d32' }}>
//                     {formatCurrency(summary.cashIn)}
//                   </Typography>
//                 </Box>
//                 <Box className={classes.summaryItem}>
//                   <Typography variant="body2">Cash Out:</Typography>
//                   <Typography style={{ color: '#c62828' }}>
//                     {formatCurrency(summary.cashOut)}
//                   </Typography>
//                 </Box>
//                 <Divider style={{ margin: '16px 0' }} />
//                 <Box className={classes.summaryItem}>
//                   <Typography variant="body1" style={{ fontWeight: 500 }}>
//                     Closing Balance:
//                   </Typography>
//                   <Typography variant="body1" style={{ fontWeight: 500 }}>
//                     {formatCurrency(summary.closingBalance)}
//                   </Typography>
//                 </Box>
//               </Box>
//             )}
//           </Paper>
//         </Grid>
//       </Grid>

//       {/* Opening Control Dialog */}
//       <Dialog open={openDialog === 'OPENING'} onClose={() => setOpenDialog(null)} className={classes.dialog}>
//         <Box className={classes.dialogTitle}>
//           <Typography variant="h6">Opening Control</Typography>
//           <IconButton onClick={() => setOpenDialog(null)}>
//             <CloseIcon />
//           </IconButton>
//         </Box>
//         <DialogContent className={classes.dialogContent}>
//           <Typography variant="subtitle2" gutterBottom>Opening cash</Typography>
//           <Box mb={2}>
//             <TextField
//               label="Opening Balance"
//               variant="outlined"
//               fullWidth
//               value={calculateTotal()}
//               InputProps={{
//                 readOnly: true,
//                 startAdornment: <InputAdornment position="start">₹</InputAdornment>,
//               }}
//             />
//             <Button 
//               variant="outlined" 
//               color="primary" 
//               fullWidth 
//               style={{ marginTop: '10px' }}
//               onClick={() => setShowDenominationsDialog(true)}
//             >
//               Add Currency Notes
//             </Button>
//           </Box>
          
//           <Typography variant="subtitle2" gutterBottom>Opening note</Typography>
//           <TextField
//             label="Add an opening note..."
//             fullWidth
//             variant="outlined"
//             multiline
//             rows={3}
//             value={notes}
//             onChange={(e) => setNotes(e.target.value)}
//           />
//         </DialogContent>
//         <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
//           <Button onClick={() => setOpenDialog(null)} style={{ marginRight: 8 }}>
//             Discard
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleSubmit}
//           >
//             Open Register
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Currency Notes Dialog */}
//       <Dialog open={showDenominationsDialog} onClose={() => setShowDenominationsDialog(false)} className={classes.dialog}>
//         <Box className={classes.dialogTitle}>
//           <Typography variant="h6">Coins/Notes</Typography>
//           <IconButton onClick={() => setShowDenominationsDialog(false)}>
//             <CloseIcon />
//           </IconButton>
//         </Box>
//         <DialogContent className={classes.dialogContent}>
//           <Grid container spacing={2}>
//             {[500, 200, 100, 50, 20, 10, 5, 2, 1].map((denomination) => (
//               <Grid item xs={6} key={denomination}>
//                 <Box display="flex" alignItems="center">
//                   <Typography variant="body1" style={{ width: '80px' }}>₹{denomination}.00</Typography>
//                   <TextField
//                     type="number"
//                     variant="outlined"
//                     size="small"
//                     value={denominations[denomination]}
//                     onChange={(e) => handleDenominationChange(denomination, e.target.value)}
//                     InputProps={{
//                       startAdornment: <InputAdornment position="start">×</InputAdornment>,
//                     }}
//                     style={{ flex: 1 }}
//                   />
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//           <Box className={classes.totalRow}>
//             <Typography variant="body2">Total:</Typography>
//             <Typography variant="body1" style={{ fontWeight: 500 }}>
//               {formatCurrency(calculateTotal())}
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
//           <Button onClick={() => setShowDenominationsDialog(false)} style={{ marginRight: 8 }}>
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={() => {
//               setShowDenominationsDialog(false);
//             }}
//           >
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Cash In/Out Dialog */}
//       <Dialog open={openDialog === 'CASH_IN_OUT'} onClose={() => setOpenDialog(null)} className={classes.dialog}>
//         <Box className={classes.dialogTitle}>
//           <Typography variant="h6">Cash In/Out</Typography>
//           <IconButton onClick={() => setOpenDialog(null)}>
//             <CloseIcon />
//           </IconButton>
//         </Box>
//         <DialogContent className={classes.dialogContent}>
//           <Box className={classes.tabContainer}>
//             <Tabs 
//               value={cashInOutTab} 
//               onChange={(e, newValue) => setCashInOutTab(newValue)}
//               indicatorColor="primary"
//               textColor="primary"
//               variant="fullWidth"
//             >
//               <Tab label="Cash In" value="CASH_IN" />
//               <Tab label="Cash Out" value="CASH_OUT" />
//             </Tabs>
//           </Box>

//           {cashInOutTab === 'CASH_IN' ? (
//             <>
//               <Button 
//                 variant="outlined" 
//                 color="primary" 
//                 fullWidth 
//                 style={{ marginBottom: '16px' }}
//                 onClick={() => setShowDenominationsDialog(true)}
//               >
//                 Add Currency Notes
//               </Button>
//               <Box className={classes.totalRow}>
//                 <Typography variant="body2">Total:</Typography>
//                 <Typography variant="body1" style={{ fontWeight: 500 }}>
//                   {formatCurrency(calculateTotal())}
//                 </Typography>
//               </Box>
//             </>
//           ) : (
//             <TextField
//               label="Amount"
//               type="number"
//               fullWidth
//               variant="outlined"
//               value={amount}
//               onChange={(e) => setAmount(e.target.value)}
//               error={!!formErrors.amount}
//               helperText={formErrors.amount}
//               InputProps={{
//                 startAdornment: <InputAdornment position="start">₹</InputAdornment>,
//               }}
//             />
//           )}

//           <TextField
//             label="Reason"
//             fullWidth
//             variant="outlined"
//             margin="normal"
//             multiline
//             rows={3}
//             value={notes}
//             onChange={(e) => setNotes(e.target.value)}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <NoteIcon color="action" />
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </DialogContent>
//         <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
//           <Button onClick={() => setOpenDialog(null)} style={{ marginRight: 8 }}>
//             Discard
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleSubmit}
//           >
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Closing Register Dialog */}
//       <Dialog open={openDialog === 'CLOSING'} onClose={() => setOpenDialog(null)} className={classes.dialog}>
//         <Box className={classes.dialogTitle}>
//           <Typography variant="h6">Closing Register</Typography>
//           <IconButton onClick={() => setOpenDialog(null)}>
//             <CloseIcon />
//           </IconButton>
//         </Box>
//         <DialogContent className={classes.dialogContent}>
//           <Typography variant="subtitle1" gutterBottom>
//             {summary?.ordersCount || 0} orders: {formatCurrency(summary?.totalSales || 0)}
//           </Typography>

//           <Table className={classes.summaryTable}>
//             <TableBody>
//               <TableRow>
//                 <TableCell component="th" scope="row">Cash</TableCell>
//                 <TableCell align="right"></TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell>Opening</TableCell>
//                 <TableCell align="right">{formatCurrency(summary?.openingBalance || 0)}</TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell>Payments in Cash</TableCell>
//                 <TableCell align="right">{formatCurrency(summary?.totalSales || 0)}</TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell>Cash In / Out</TableCell>
//                 <TableCell align="right">
//                   {formatCurrency((summary?.cashIn || 0) - (summary?.cashOut || 0))}
//                 </TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell>Counted</TableCell>
//                 <TableCell align="right">
//                   <TextField
//                     type="number"
//                     variant="outlined"
//                     size="small"
//                     value={amount}
//                     onChange={(e) => setAmount(e.target.value)}
//                     InputProps={{
//                       startAdornment: <InputAdornment position="start">₹</InputAdornment>,
//                     }}
//                     style={{ width: '120px' }}
//                   />
//                 </TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell>Difference</TableCell>
//                 <TableCell align="right">
//                   {formatCurrency(
//                     (summary?.openingBalance || 0) + 
//                     (summary?.totalSales || 0) + 
//                     ((summary?.cashIn || 0) - (summary?.cashOut || 0)) - 
//                     (parseFloat(amount) || 0)
//                   )}
//                 </TableCell>
//               </TableRow>
//             </TableBody>
//           </Table>

//           <Typography variant="subtitle2" gutterBottom>Closing note</Typography>
//           <TextField
//             label="Add a closing note..."
//             fullWidth
//             variant="outlined"
//             multiline
//             rows={3}
//             value={notes}
//             onChange={(e) => setNotes(e.target.value)}
//           />
//         </DialogContent>
//         <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
//           <Button onClick={() => setOpenDialog(null)} style={{ marginRight: 8 }}>
//             Discard
//           </Button>
//           <Button
//             variant="outlined"
//             onClick={() => handleOpenDialog('CASH_IN_OUT')}
//             style={{ marginRight: 8 }}
//           >
//             Cash In/Out
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleCloseRegister}
//           >
//             Close Register
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default CashManagement;

import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createCashTransaction,
  fetchCashTransactions,
  closeRegister,
  fetchCashSummary,
  generateDailyReport,
} from '../../actions/cashTransactionActions';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Paper,
  Divider,
  IconButton,
  Box,
  InputAdornment,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close as CloseIcon, AttachMoney as MoneyIcon, Note as NoteIcon, PictureAsPdf as PdfIcon } from '@material-ui/icons';
import moment from 'moment';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    marginLeft: "85px"
  },
  header: {
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: 4,
    marginBottom: theme.spacing(2),
    boxShadow: '0 1px 2px 0 rgba(0,0,0,0.1)',
  },
  actionButton: {
    margin: theme.spacing(0.5),
    textTransform: 'none',
    borderRadius: 4,
    padding: theme.spacing(1, 2),
    boxShadow: 'none',
    '&.cash-in': {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
      '&:hover': {
        backgroundColor: '#c8e6c9',
      },
    },
    '&.cash-out': {
      backgroundColor: '#ffebee',
      color: '#c62828',
      '&:hover': {
        backgroundColor: '#ffcdd2',
      },
    },
    '&.close': {
      backgroundColor: '#e3f2fd',
      color: '#1565c0',
      '&:hover': {
        backgroundColor: '#bbdefb',
      },
    },
  },
  dialog: {
    '& .MuiDialog-paper': {
      width: '400px',
      maxWidth: '100%',
    },
    '&.wide-dialog .MuiDialog-paper': {
      width: '600px',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    borderBottom: '1px solid #e0e0e0',
  },
  dialogContent: {
    padding: theme.spacing(3),
  },
  denominationRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    '& .label': {
      width: '100px',
      color: theme.palette.text.secondary,
    },
    '& .input': {
      flex: 1,
    },
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
    marginTop: theme.spacing(2),
  },
  summaryCard: {
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: 4,
    marginBottom: theme.spacing(2),
    boxShadow: '0 1px 2px 0 rgba(0,0,0,0.1)',
  },
  summaryItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  transactionItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2),
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  transactionAmount: {
    fontWeight: 500,
    '&.cash-in': {
      color: '#2e7d32',
    },
    '&.cash-out': {
      color: '#c62828',
    },
  },
  tabContainer: {
    marginBottom: theme.spacing(2),
  },
  currencyButton: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  summaryTable: {
    marginBottom: theme.spacing(2),
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      padding: theme.spacing(1),
    },
    '& .MuiTableCell-head': {
      fontWeight: 'bold',
    },
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  openingBalanceInput: {
    '& .MuiInputBase-root': {
      backgroundColor: '#f5f5f5',
    },
  },
  cashInOutButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    '& button': {
      width: '48%',
    },
  },
}));

const CashManagement = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { transactions, summary, isLoading } = useSelector((state) => state.cashTransactions);
  const user = JSON.parse(localStorage.getItem('profile'));

  const [openDialog, setOpenDialog] = useState(null);
  const [amount, setAmount] = useState('');
  const [notes, setNotes] = useState('');
  const [denominations, setDenominations] = useState({
    500: 0,
    200: 0,
    100: 0,
    50: 0,
    20: 0,
    10: 0,
    5: 0,
    2: 0,
    1: 0,
  });
  const [formErrors, setFormErrors] = useState({});
  const [cashInOutTab, setCashInOutTab] = useState('CASH_IN');
  const [showDenominationsDialog, setShowDenominationsDialog] = useState(false);

  const fetchData = useCallback(() => {
    const today = moment().format('YYYY-MM-DD');
    dispatch(fetchCashSummary(today));
    dispatch(fetchCashTransactions(today, today));
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const validateForm = () => {
    const errors = {};
    if (openDialog === 'OPENING' || (openDialog === 'CASH_IN_OUT' && cashInOutTab === 'CASH_IN')) {
      const totalAmount = Object.entries(denominations).reduce(
        (sum, [denom, count]) => sum + parseInt(denom) * count,
        0
      );
      if (totalAmount <= 0) {
        errors.denominations = 'Please enter at least one denomination';
      }
    }
    if ((openDialog === 'CASH_IN_OUT' && cashInOutTab === 'CASH_OUT') && (!amount || parseFloat(amount) <= 0)) {
      errors.amount = 'Please enter a valid amount';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleOpenDialog = (type) => {
    setOpenDialog(type);
    setAmount('');
    setNotes('');
    setDenominations({
      500: 0,
      200: 0,
      100: 0,
      50: 0,
      20: 0,
      10: 0,
      5: 0,
      2: 0,
      1: 0,
    });
    setFormErrors({});
    if (type === 'CASH_IN_OUT') {
      setCashInOutTab('CASH_IN');
    }
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    const totalAmount = Object.entries(denominations).reduce(
      (sum, [denom, count]) => sum + parseInt(denom) * count,
      0
    );

    const transaction = {
      type: openDialog === 'CASH_IN_OUT' ? cashInOutTab : openDialog,
      amount: openDialog === 'OPENING' || (openDialog === 'CASH_IN_OUT' && cashInOutTab === 'CASH_IN') 
        ? totalAmount 
        : parseFloat(amount),
      denominations: openDialog === 'OPENING' || (openDialog === 'CASH_IN_OUT' && cashInOutTab === 'CASH_IN') 
        ? denominations 
        : {},
      notes,
      creator: user?.result?._id,
    };

    dispatch(createCashTransaction(transaction, (success) => {
      if (success) {
        setOpenDialog(null);
        setShowDenominationsDialog(false);
        fetchData();
      }
    }));
  };

  const handleCloseRegister = () => {
    if (!validateForm()) return;

    dispatch(closeRegister({ cashOutAmount: parseFloat(amount) || 0, notes }, (success) => {
      if (success) {
        setOpenDialog(null);
        fetchData();
      }
    }));
  };

  const formatCurrency = (value) => {
    if (value === undefined || value === null) return '₹0.00';
    return `₹${parseFloat(value).toFixed(2)}`;
  };

  const calculateTotal = () => {
    return Object.entries(denominations).reduce(
      (sum, [denom, count]) => sum + parseInt(denom) * count,
      0
    );
  };

  const handleDenominationChange = (denomination, value) => {
    setDenominations({
      ...denominations,
      [denomination]: parseInt(value) || 0,
    });
  };

  // const handleDownloadReport = async () => {
  //   try {
  //     const today = moment().format('YYYY-MM-DD');
  //     const { data: reportData } = await dispatch(generateDailyReport(today));
  
  //     // Create PDF
  //     const doc = new jsPDF();
  
  //     // Apply autoTable to jsPDF instance
  //     doc.autoTable = autoTable;
  
  //     // Title
  //     doc.setFontSize(18);
  //     doc.text('Daily Cash Report', 105, 20, { align: 'center' });
  
  //     // Date
  //     doc.setFontSize(12);
  //     doc.text(`Date: ${moment().format('DD/MM/YYYY')}`, 14, 30);
  
  //     // Summary Table
  //     doc.autoTable({
  //       startY: 40,
  //       head: [['Item', 'Amount']],
  //       body: [
  //         ['Opening Balance', formatCurrency(reportData.openingBalance)],
  //         ['Total Sales', formatCurrency(reportData.totalSales)],
  //         ['Cash In', formatCurrency(reportData.cashIn)],
  //         ['Cash Out', formatCurrency(reportData.cashOut)],
  //         ['Closing Balance', formatCurrency(reportData.closingBalance)],
  //       ],
  //       theme: 'grid',
  //       headStyles: { fillColor: [41, 128, 185], textColor: 255 },
  //     });
  
  //     // Transactions Table
  //     doc.setFontSize(14);
  //     doc.text('Transactions', 14, doc.autoTable.previous.finalY + 20);
  
  //     doc.autoTable({
  //       startY: doc.autoTable.previous.finalY + 25,
  //       head: [['Time', 'Type', 'Amount', 'Notes']],
  //       body: reportData.transactions.map((tx) => [
  //         moment(tx.date).format('h:mm A'),
  //         tx.type === 'CASH_IN'
  //           ? 'Cash In'
  //           : tx.type === 'CASH_OUT'
  //           ? 'Cash Out'
  //           : tx.type === 'OPENING'
  //           ? 'Opening'
  //           : 'Closing',
  //         formatCurrency(tx.amount),
  //         tx.notes || '',
  //       ]),
  //       theme: 'grid',
  //       headStyles: { fillColor: [41, 128, 185], textColor: 255 },
  //       columnStyles: {
  //         0: { cellWidth: 25 },
  //         1: { cellWidth: 30 },
  //         2: { cellWidth: 25 },
  //         3: { cellWidth: 'auto' },
  //       },
  //     });
  
  //     // Save the PDF
  //     doc.save(`Cash_Report_${moment().format('YYYYMMDD')}.pdf`);
  //   } catch (error) {
  //     console.error('Error generating report:', error);
  //   }
  // };

  // const formatCurrency = (value) => {
  //   if (value === undefined || value === null) return 'THB 0.00';
  //   return `THB ${parseFloat(value).toFixed(2)}`;
  // };
  // const handleDownloadReport = async () => {
  //   try {
  //     const today = moment().format('YYYY-MM-DD');
  //     const { data: reportData } = await dispatch(generateDailyReport(today));
  
  //     // Create PDF
  //     const doc = new jsPDF();
  
  //     // Title
  //     doc.setFontSize(18);
  //     doc.text('Daily Cash Report', 105, 20, { align: 'center' });
  
  //     // Date
  //     doc.setFontSize(12);
  //     doc.text(`Date: ${moment().format('DD/MM/YYYY')}`, 14, 30);
  
  //     // Summary Table
  //     autoTable(doc, {
  //       startY: 40,
  //       head: [['Item', 'Amount']],
  //       body: [
  //         ['Opening Balance', formatCurrency(reportData.openingBalance)],
  //         ['Total Sales', formatCurrency(reportData.totalSales)],
  //         ['Cash In', formatCurrency(reportData.cashIn)],
  //         ['Cash Out', formatCurrency(reportData.cashOut)],
  //         ['Closing Balance', formatCurrency(reportData.closingBalance)],
  //       ],
  //       theme: 'grid',
  //       headStyles: { fillColor: [41, 128, 185], textColor: 255 },
  //     });
  
  //     // Transactions Table
  //     doc.setFontSize(14);
  //     doc.text('Transactions', 14, doc.lastAutoTable.finalY + 20);
  
  //     autoTable(doc, {
  //       startY: doc.lastAutoTable.finalY + 25,
  //       head: [['Time', 'Type', 'Amount', 'Notes']],
  //       body: reportData.transactions.map((tx) => [
  //         moment(tx.date).format('h:mm A'),
  //         tx.type === 'CASH_IN'
  //           ? 'Cash In'
  //           : tx.type === 'CASH_OUT'
  //           ? 'Cash Out'
  //           : tx.type === 'OPENING'
  //           ? 'Opening'
  //           : 'Closing',
  //         formatCurrency(tx.amount),
  //         tx.notes || '',
  //       ]),
  //       theme: 'grid',
  //       headStyles: { fillColor: [41, 128, 185], textColor: 255 },
  //       columnStyles: {
  //         0: { cellWidth: 25 },
  //         1: { cellWidth: 30 },
  //         2: { cellWidth: 25 },
  //         3: { cellWidth: 'auto' },
  //       },
  //     });
  
  //     // Save the PDF
  //     doc.save(`Cash_Report_${moment().format('YYYYMMDD')}.pdf`);
  //   } catch (error) {
  //     console.error('Error generating report:', error);
  //   }
  // };

  const handleDownloadReport = async () => {
    try {
      const today = moment().format('YYYY-MM-DD');
      const { data: reportData } = await dispatch(generateDailyReport(today));
  
      // Create PDF
      const doc = new jsPDF();
  
      // Set a default font
      doc.setFont('helvetica');
  
      // Title
      doc.setFontSize(18);
      doc.text('Daily Cash Report', 105, 20, { align: 'center' });
  
      // Date
      doc.setFontSize(12);
      doc.text(`Date: ${moment().format('DD/MM/YYYY')}`, 14, 30);
  
      // Summary Table
      autoTable(doc, {
        startY: 40,
        head: [['Item', 'Amount']],
        body: [
          ['Opening Balance', `${parseFloat(reportData.openingBalance || 0).toFixed(2)}`],
          ['Total Sales', `${parseFloat(reportData.totalSales || 0).toFixed(2)}`],
          ['Cash In', `${parseFloat(reportData.cashIn || 0).toFixed(2)}`],
          ['Cash Out', `${parseFloat(reportData.cashOut || 0).toFixed(2)}`],
          ['Closing Balance', `${parseFloat(reportData.closingBalance || 0).toFixed(2)}`],
        ],
        theme: 'grid',
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        styles: { font: 'helvetica' },
      });
  
      // Transactions Table
      doc.setFontSize(14);
      doc.text('Transactions', 14, doc.lastAutoTable.finalY + 20);
  
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 25,
        head: [['Time', 'Type', 'Amount', 'Notes']],
        body: reportData.transactions.map((tx) => [
          moment(tx.date).format('h:mm A'),
          tx.type === 'CASH_IN'
            ? 'Cash In'
            : tx.type === 'CASH_OUT'
            ? 'Cash Out'
            : tx.type === 'OPENING'
            ? 'Opening'
            : 'Closing',
   `${parseFloat(tx.amount || 0).toFixed(2)}`,
          tx.notes || '',
        ]),
        theme: 'grid',
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        columnStyles: {
          0: { cellWidth: 25 },
          1: { cellWidth: 30 },
          2: { cellWidth: 25 },
          3: { cellWidth: 'auto' },
        },
        styles: { font: 'helvetica' },
      });
  
      // Save the PDF
      doc.save(`Cash_Report_${moment().format('YYYYMMDD')}.pdf`);
    } catch (error) {
      console.error('Error generating report:', error);
    }
  };
  return (
    <div className={classes.root}>
      <Paper className={classes.header}>
        <Typography variant="h6">Cash Management</Typography>
      </Paper>

      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Paper className={classes.summaryCard}>
            <Typography variant="subtitle1" gutterBottom>
              Quick Actions
            </Typography>
            <Divider style={{ marginBottom: 16 }} />
            <Box display="flex" flexWrap="wrap">
              <Button
                variant="contained"
                className={`${classes.actionButton}`}
                startIcon={<MoneyIcon />}
                onClick={() => handleOpenDialog('OPENING')}
              >
                Opening Control
              </Button>
              <Button
                variant="contained"
                className={`${classes.actionButton} cash-in`}
                startIcon={<MoneyIcon />}
                onClick={() => handleOpenDialog('CASH_IN_OUT')}
              >
                Cash In
              </Button>
              <Button
                variant="contained"
                className={`${classes.actionButton} cash-out`}
                startIcon={<MoneyIcon />}
                onClick={() => handleOpenDialog('CASH_IN_OUT')}
              >
                Cash Out
              </Button>
              <Button
                variant="contained"
                className={`${classes.actionButton} close`}
                startIcon={<MoneyIcon />}
                onClick={() => handleOpenDialog('CLOSING')}
              >
                Close Register
              </Button>
              <Button
                variant="contained"
                className={classes.actionButton}
                startIcon={<PdfIcon />}
                onClick={handleDownloadReport}
                style={{ backgroundColor: '#d32f2f', color: '#fff' }}
              >
                Download Report
              </Button>
            </Box>
          </Paper>

          <Paper className={classes.summaryCard}>
            <Typography variant="subtitle1" gutterBottom>
              Today's Transactions
            </Typography>
            <Divider style={{ marginBottom: 16 }} />
            {isLoading ? (
              <Box display="flex" justifyContent="center" py={4}>
                <Typography>Loading...</Typography>
              </Box>
            ) : transactions.length === 0 ? (
              <Typography color="textSecondary" align="center" py={4}>
                No transactions today
              </Typography>
            ) : (
              <Box>
                {transactions.map((tx) => (
                  <Box key={tx._id} className={classes.transactionItem}>
                    <Box>
                      <Typography variant="body2">
                        {moment(tx.date).format('h:mm A')}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {tx.type === 'CASH_IN' ? 'Cash In' : 
                         tx.type === 'CASH_OUT' ? 'Cash Out' : 
                         tx.type === 'OPENING' ? 'Opening Balance' : 'Closing Balance'}
                      </Typography>
                    </Box>
                    <Typography 
                      className={`${classes.transactionAmount} ${
                        tx.type === 'CASH_IN' || tx.type === 'OPENING' ? 'cash-in' : 'cash-out'
                      }`}
                    >
                      {formatCurrency(tx.amount)}
                    </Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper className={classes.summaryCard}>
            <Typography variant="subtitle1" gutterBottom>
              Cash Summary
            </Typography>
            <Divider style={{ marginBottom: 16 }} />
            {summary && (
              <Box>
                <Box className={classes.summaryItem}>
                  <Typography variant="body2">Opening Balance:</Typography>
                  <Typography>{formatCurrency(summary.openingBalance)}</Typography>
                </Box>
                <Box className={classes.summaryItem}>
                  <Typography variant="body2">Total Sales:</Typography>
                  <Typography>{formatCurrency(summary.totalSales)}</Typography>
                </Box>
                <Box className={classes.summaryItem}>
                  <Typography variant="body2">Cash In:</Typography>
                  <Typography style={{ color: '#2e7d32' }}>
                    {formatCurrency(summary.cashIn)}
                  </Typography>
                </Box>
                <Box className={classes.summaryItem}>
                  <Typography variant="body2">Cash Out:</Typography>
                  <Typography style={{ color: '#c62828' }}>
                    {formatCurrency(summary.cashOut)}
                  </Typography>
                </Box>
                <Divider style={{ margin: '16px 0' }} />
                <Box className={classes.summaryItem}>
                  <Typography variant="body1" style={{ fontWeight: 500 }}>
                    Closing Balance:
                  </Typography>
                  <Typography variant="body1" style={{ fontWeight: 500 }}>
                    {formatCurrency(summary.closingBalance)}
                  </Typography>
                </Box>
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>

      {/* Opening Control Dialog - Matches 1st screenshot exactly */}
      <Dialog open={openDialog === 'OPENING'} onClose={() => setOpenDialog(null)} className={classes.dialog}>
        <Box className={classes.dialogTitle}>
          <Typography variant="h6">Opening Control</Typography>
          <IconButton onClick={() => setOpenDialog(null)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 'bold' }}>Opening cash</Typography>
          <Box mb={2}>
            <TextField
              label="Opening Balance Eg: 12:"
              variant="outlined"
              fullWidth
              value={calculateTotal()}
              className={classes.openingBalanceInput}
              InputProps={{
                readOnly: true,
                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              }}
            />
            <Button 
              variant="outlined" 
              color="primary" 
              fullWidth 
              style={{ marginTop: '10px' }}
              onClick={() => setShowDenominationsDialog(true)}
            >
              Add Currency Notes
            </Button>
          </Box>
          
          <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 'bold' }}>Opening note</Typography>
          <TextField
            label="Add an opening note..."
            fullWidth
            variant="outlined"
            multiline
            rows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => setOpenDialog(null)} style={{ marginRight: 8 }}>
            Discard
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Open Register
          </Button>
        </DialogActions>
      </Dialog>

      {/* Currency Notes Dialog - Matches 2nd screenshot exactly */}
      <Dialog open={showDenominationsDialog} onClose={() => setShowDenominationsDialog(false)} className={classes.dialog}>
        <Box className={classes.dialogTitle}>
          <Typography variant="h6">Coins/Notes</Typography>
          <IconButton onClick={() => setShowDenominationsDialog(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent className={classes.dialogContent}>
          <Grid container spacing={2}>
            {[500, 200, 100, 50, 20, 10, 5, 2, 1].map((denomination) => (
              <Grid item xs={4} key={denomination}>
                <Box display="flex" alignItems="center">
                  <Typography variant="body1" style={{ width: '60px' }}>₹{denomination}.00</Typography>
                  <TextField
                    type="number"
                    variant="outlined"
                    size="small"
                    value={denominations[denomination]}
                    onChange={(e) => handleDenominationChange(denomination, e.target.value)}
                    // InputProps={{
                    //   startAdornment: <InputAdornment position="start">+</InputAdornment>,
                    // }}
                    style={{ flex: 1 }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
          <Box className={classes.totalRow}>
            <Typography variant="body2">Total:</Typography>
            <Typography variant="body1" style={{ fontWeight: 500 }}>
              {formatCurrency(calculateTotal())}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => setShowDenominationsDialog(false)} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setShowDenominationsDialog(false);
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Cash In/Out Dialog - Matches 3rd screenshot exactly */}
      <Dialog open={openDialog === 'CASH_IN_OUT'} onClose={() => setOpenDialog(null)} className={classes.dialog}>
        <Box className={classes.dialogTitle}>
          <Typography variant="h6">Cash In / Cash Out</Typography>
          <IconButton onClick={() => setOpenDialog(null)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent className={classes.dialogContent}>
          <Box className={classes.cashInOutButtons}>
            <Button 
              variant={cashInOutTab === 'CASH_IN' ? 'contained' : 'outlined'} 
              color="primary"
              onClick={() => setCashInOutTab('CASH_IN')}
            >
              Cash In
            </Button>
            <Button 
              variant={cashInOutTab === 'CASH_OUT' ? 'contained' : 'outlined'} 
              color="secondary"
              onClick={() => setCashInOutTab('CASH_OUT')}
            >
              Cash Out
            </Button>
          </Box>

          {cashInOutTab === 'CASH_IN' ? (
            <>
              <Button 
                variant="outlined" 
                color="primary" 
                fullWidth 
                style={{ marginBottom: '16px' }}
                onClick={() => setShowDenominationsDialog(true)}
              >
                Add Currency Notes
              </Button>
              <Box className={classes.totalRow}>
                <Typography variant="body2">Total:</Typography>
                <Typography variant="body1" style={{ fontWeight: 500 }}>
                  {formatCurrency(calculateTotal())}
                </Typography>
              </Box>
            </>
          ) : (
            <TextField
              label="Amount"
              type="number"
              fullWidth
              variant="outlined"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              error={!!formErrors.amount}
              helperText={formErrors.amount}
              InputProps={{
                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              }}
            />
          )}

          <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 'bold', marginTop: '16px' }}>Reason</Typography>
          <TextField
            fullWidth
            variant="outlined"
            multiline
            rows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => setOpenDialog(null)} style={{ marginRight: 8 }}>
            Discard
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Closing Register Dialog - Matches 4th screenshot exactly (without card/customer account) */}
      <Dialog open={openDialog === 'CLOSING'} onClose={() => setOpenDialog(null)} className={`${classes.dialog} wide-dialog`}>
        <Box className={classes.dialogTitle}>
          <Typography variant="h6">Closing Register</Typography>
          <IconButton onClick={() => setOpenDialog(null)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="subtitle1" gutterBottom>
            {summary?.ordersCount || 0} orders: {formatCurrency(summary?.totalSales || 0)}
          </Typography>

          <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>Cash</Typography>
          <Table className={classes.summaryTable}>
            <TableBody>
              <TableRow>
                <TableCell>Opening</TableCell>
                <TableCell align="right">{formatCurrency(summary?.openingBalance || 0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Payments in Cash</TableCell>
                <TableCell align="right">{formatCurrency(summary?.totalSales || 0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Cash In / Out</TableCell>
                <TableCell align="right">
                  {summary?.transactions?.map(tx => (
                    <div key={tx._id}>
                      {tx.type === 'CASH_IN' && `+ ${formatCurrency(tx.amount)}`}
                      {tx.type === 'CASH_OUT' && `- ${formatCurrency(tx.amount)}`}
                    </div>
                  ))}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Counted</TableCell>
                <TableCell align="right">
                  <TextField
                    type="number"
                    variant="outlined"
                    size="small"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                    }}
                    style={{ width: '120px' }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Difference</TableCell>
                <TableCell align="right">
                  {formatCurrency(
                    (summary?.openingBalance || 0) + 
                    (summary?.totalSales || 0) + 
                    ((summary?.cashIn || 0) - (summary?.cashOut || 0)) - 
                    (parseFloat(amount) || 0)
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 'bold' }}>Closing note</Typography>
          <TextField
            label="Add a closing note..."
            fullWidth
            variant="outlined"
            multiline
            rows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => setOpenDialog(null)} style={{ marginRight: 8 }}>
            Discard
          </Button>
          <Button
            variant="outlined"
            onClick={() => handleOpenDialog('CASH_IN_OUT')}
            style={{ marginRight: 8 }}
          >
            Cash In/Out
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCloseRegister}
          >
            Close Register
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CashManagement;